!function(window, $, undefined){
    'use strict';

    class App {

        constructor(){
            this.stack = [];
            this.started = false;
            this.sorted = false;
        }

        use(scope, context){
            scope = App.normalizeScope(scope);

            if(!this.sorted){
                this.stack.sort(function(a, b){
                    if(a.order === b.order){
                        return 0;
                    }
                    return a.order > b.order ? 1 : -1;
                });

                this.sorted = true;
            }

            this.stack
                .filter(stack => scope.some(scope => stack.scope.indexOf(scope) > -1))
                .map(stack => stack.callback.call(this, context, scope));
        }

        bind(scope, callback, order){
            if(order === undefined){
                if(callback === undefined){
                    callback = scope;
                    scope = ['default'];

                }else if(typeof callback === 'number') {
                    order = callback || 0;
                    callback = scope;
                    scope = ['default'];
                }
            }

            if(order === undefined){
                order = 0;
            }

            scope = App.normalizeScope(scope);

            this.stack.push({scope, callback, order});
            this.sorted = false;
        }


        start(){
            if(this.started !== false){
                return;
            }

            this.started = true;

            $(() =>{
                this.use('default');
            });
        }

        static normalizeScope(scope){
            if(typeof scope === 'string'){
                scope = scope.split(' ').map(scope => scope.trim());
            }

            if(scope.length === 0){
                scope = ['default'];
            }

            return scope;
        }
    }

    window.app = new App;

}(window, jQuery);

!function () {
    const _pluralize = (n, titles, noNumber) => `${noNumber ? '' : n + ' '}${(typeof titles === 'string' ? titles.split('|') : titles)[n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2]}`;
    app.pluralize = _pluralize;
    app.textPluralize = (n, titles) => _pluralize(n, titles, true);
}();

app.isInViewport = ($element, options = {edge: 'all', offset: 0}) => {
    const element = (($element instanceof jQuery) ? $element[0] : $element);
    const rect = element.getBoundingClientRect();
    if ( options.edge == 'top' ) {
        return rect.top >= window.innerHeight || rect.top < 0;
    }
    return (rect.top > 0 ? rect.top + element.offsetHeight + document.documentElement.scrollTop <= window.innerHeight + document.documentElement.scrollTop : rect.top + document.documentElement.scrollTop >= window.innerHeight + document.documentElement.scrollTop);
}

app.prettyPrice = (price, symbol = ' ₽') => `${ price.toString().replace(/\./g, ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ') }${symbol ? symbol : ''}`;
app.prettyNumber = (price, symbol = false) => app.prettyPrice(price, symbol);

app.uid = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});

app.triggerEvent = (eventName, _elem) => {
    const event = new CustomEvent(eventName);
    if ( _elem instanceof jQuery ) {
        _elem.each((itemIndex, item) => {
            item.dispatchEvent(event);
        });
    }
    else {
        _elem.dispatchEvent(event);
    }
    return _elem;
};

(function($, window, undefined){
    const errorMessages = {
        ru: {
            valueMissing: {
                default: 'Заполните поле',
                email: 'Введите почту',
                _username: 'Введите логин',
                phone: 'Введите номер телефона',
                terms: 'Вы должны согласиться с условями',
                size: 'Выберите размер',
                promocode: 'Введите промокод',
                name: 'Введите имя',
                company: 'Введите название компании и адрес сайта',
                firstname: 'Введите имя',
                lastname: 'Введите фамилию',
                password: 'Введите пароль',
            },
            typeMismatch: {
                default: 'Неверный формат',
                phone: 'Неверный формат телефона',
                email: 'Неверный формат почты',
            },
            tooShort: {
                default: 'Недостаточно символов',
            },
            tooLong: {
                default: 'Слишком длинное значение',
            },
            rangeOverflow: {
                default: 'Значение больше максимального',
            },
            rangeUnderflow: {
                default: 'Значение меньше минимального',
            },
            different: {
                default: 'Значения не совпадают',
            },
            limit: {
                default: 'Много одинаковых значений',
            },
        },
    };

    const processRequestError = function($form, errors){
        const errorsObj = Object.keys(errors);
        let $allFields = $();

        errorsObj.map((field, fieldIndex) =>{
            const formTag = $form[0].tagName;
            let message = errors[field];
            let $fields = formTag == 'INPUT' || formTag == 'TEXTAREA' ? $form : $form.find(`[name="${field}"], [name^="${field}["]`);

            if($form.attr('id')){
                $fields = $fields.add(`[name="${field}"][form="${$form.attr('id')}"], [name^="${field}["][form="${$form.attr('id')}"]`)
            }

            $allFields = $allFields.add($fields);

            $fields.each((i, input) =>{
                const isToggle = input.type == 'checkbox' || input.type == 'radio';
                const $input = $(input);
                const $field = isToggle ? $input.closest('.toggle') : $input.closest('.field');
                let group = $field.data('inputs-group');
                let $group = $();

                if ( input.name.indexOf('/error') >= 0 ) {
                    input.name = input.name.split('/error')[0];
                }

                if ( group ) {
                    $group = $input.closest(`[js-inputShadow-group][data-inputs-group="${group}"]`);
                }

                if( isToggle ){
                    $input.data({valid: false}).trigger('invalid');
                }

                if ( group && $group.length ) {
                    let $error = $group.find('.inputs-group__error');

                    if (!$error.length ) {
                        $error = $(`<div class="inputs-group__error"></div>`).appendTo($group);
                        $error[0].offsetWidth;
                    }
                    $error.html(message);
                    $group.addClass('is-error');
                }
                else if ( !isToggle ) {
                    let $error = $field.find('.field__error');
                    if (!$error.length) {
                        $error = $('<span class="field__error" />');
                        $field.append($error);
                        $error[0].offsetWidth;
                    }
                    $error.html(message);
                }

                $field.removeClass('is-ok').addClass('is-error');
            });

            if ( formTag == 'FORM' ) {
                const $submit = $form.find('[type="submit"]');
                $form
                    .off('.catch-change')
                    .on('valid.catch-change invalid.catch-change', (e) => {
                        $submit.removeClass('is-error');
                    });
                $submit.addClass('is-error');
            }
        });

        if ( $.scrollTo ) {
            const $firstErrorField = $allFields.filter(':visible, [type="checkbox"], [type="radio"]').eq(0);
            if ( $firstErrorField.length && !app.isInViewport($firstErrorField) ){
                $.scrollTo($firstErrorField.closest('.toggle, .field'));
            }
        }
    };

    const testInput = function (input) {
        const error = {};
        const locale = 'ru';
        const isCompare = input.dataset && input.dataset.compare;
        const isLimit = input.dataset && input.dataset.limit;
        const isValidate = input.dataset && !!input.dataset.validate;
        const isRequired = input.required;
        let $helpInputs = $();

        if ( isValidate && !isRequired ) {
            input.required = true;
        }

        if ( isCompare ) {
            $helpInputs = $(input).closest('form').find(`[name="${input.dataset.compare}"]`);
        }
        if ( isLimit ) {
            $helpInputs = $(input).closest('form').find(`[name="${input.name}"]`);
        }

        // console.log(input.name, input.disabled, input.value, input.dataset && input.dataset.isInputmask == "true" ? 'inputmask' : '', input.validity.valid);
        if ( input.disabled ) {
            // Что-то делать или нет?
            // console.log(input.name, 'disabled')
        }
        else if ( input.validity.valueMissing ) {
            error[input.name] = errorMessages[locale].valueMissing[input.name || input.type] || errorMessages[locale].valueMissing['default'];
            // Поле не заполнено
        }
        else if ( input.value.length && (input.type == 'email' || input.name == 'email' ) && !Inputmask.isValid(input.value.toLowerCase(), {regex: '[a-zA-Z0-9._-]+@([a-zA-Z0-9-]+\.){1,3}[a-zA-Z]{2,4}'}) ) {
            // Слишком не email
            error[input.name] = errorMessages[locale].typeMismatch['email'] || errorMessages[locale].typeMismatch['default'];
        }
        else if ( input.dataset && input.dataset.isInputmask == "true" && !$(input).inputmask('isComplete') ) {
            error[input.name] = errorMessages[locale].typeMismatch[input.name] || errorMessages[locale].typeMismatch['default'];
        }
        else if ( input.validity.tooShort || input.minlength && input.value.length < input.minlength ) {
            // Слишком короткий
            error[input.name] = errorMessages[locale].tooShort[input.name] || errorMessages[locale].tooShort['default'];
        }
        else if ( input.validity.tooLong ) {
            // Слишком длинный
            error[input.name] = errorMessages[locale].tooLong[input.name] || errorMessages[locale].tooLong['default'];
        }
        else if ( input.validity.typeMismatch ) {
            // Работает только на email и url, лучше использовать для этого inputmask
            error[input.name] = errorMessages[locale].typeMismatch[input.name] || errorMessages[locale].typeMismatch[input.type] || errorMessages[locale].typeMismatch['default'];
        }
        else if ( input.validity.rangeOverflow ) {
            // Число больше максимального
            error[input.name] = errorMessages[locale].rangeOverflow[input.name] || errorMessages[locale].rangeOverflow['default'];
        }
        else if ( input.validity.rangeUnderflow ) {
            // Число меньше минимального
            error[input.name] = errorMessages[locale].rangeUnderflow[input.name] || errorMessages[locale].rangeUnderflow['default'];
        }
        else if ( isCompare && $helpInputs.val().length > 0 && input.value !== $helpInputs.val() ) {
            // Значения различаются
            error[input.name] = errorMessages[locale].different[input.name] || errorMessages[locale].different['default'];
        }
        else if ( isLimit && $helpInputs.toArray().filter((helpInput) => helpInput.value == input.value).length > input.dataset.limit ) {
            // Много одинаковых значений
            error[input.name] = errorMessages[locale].limit[input.name] || errorMessages[locale].limit['default'];
        }

        if ( isValidate && !isRequired ) {
            input.required = false;
        }

        return error;
    }

    $.fn.formClearError = function(){
        this.find('.field.is-error, .toggle.is-error, .fieldset.is-error').removeClass('is-error');
        return this;
    };

    $.fn.formError = function(errors = {}){
        processRequestError(this, errors);
        return this;
    };

    $.fn.inputValidate = function(simple){
        const errors = testInput(this[0]);
        if ( !simple ) {
            processRequestError(this, errors);
        }
        return errors;
    };

    $.fn.formValidate = function(options = {isBoolean: false, hideErrors: false}){
        this.formClearError();
        const $inputs = this.find('input[hidden], input:visible, textarea:visible, select:visible, .selectus:visible select, .toggle:visible input');

        let errors = {};

        $.each($inputs.toArray().reverse(), (inputIndex, input) => {
            const test = testInput(input);
            if ( !$.isEmptyObject(test) ) {
                errors = {...errors, ...{[input.name +'/error'+ inputIndex]: test[input.name]}};
                if ( options.isBoolean ) return false;
                if ( !options.hideErrors ) {
                    input.name += '/error'+ inputIndex;
                }
            }
        });

        if ( options.isBoolean ) {
            return !Object.keys(errors).length;
        }
        else if ( !options.hideErrors ) {
            processRequestError(this, errors);
        }
        return errors;
    };


    $.fn.form = function({isValid: isValid, success: successCallback, error: errorCallback, beforeSend: beforeSendCallback, complete: completeCallback} = {}){
        this.each(function(i, form){
            const $form = $(form);
            let lock;

            $form.off('.form').on('submit.form', function(e){
                e.preventDefault();

                const validateErrors = $form.formValidate();

                if(lock || !$.isEmptyObject(validateErrors) || (typeof isValid === 'function' && !isValid.call(null, form))){
                    return;
                }

                lock = true;
                let data;
                const $files = $form.find('[type="file"]');

                if($files.length){
                    data = new FormData(form);
                    $files.each(function(i, input){
                        data.append(input.name, input);
                    });
                }else{
                    data = $form.serialize();
                }

                const $submit = $form.find('button[type=submit]');

                $.ajax({
                    url: $form.attr('action'),
                    type: $form.attr('method') || 'post',
                    dataType: 'json',
                    data: data,
                    contentType: (data instanceof FormData) ? false : 'application/x-www-form-urlencoded' ,
                    processData: !(data instanceof FormData),
                    beforeSend: function(xhr, settings){
                        $form.addClass('is-loading').formClearError();
                        $submit.prop('disabled', true);

                        if(beforeSendCallback){
                            beforeSendCallback.call(null, xhr, form, settings)
                        }
                    },
                    success: function(response){
                        if(successCallback){
                            successCallback.call(null, response, form)
                        }
                    },
                    error: function(xhr){
                        app
                            .processError(xhr, {
                                request: errors => processRequestError($form, errors)
                            })
                            .then(errorCallback || function(){});
                    },
                    complete: function(response){
                        lock = false;
                        $form.removeClass('is-loading');
                        $submit.prop('disabled', false);

                        if(completeCallback){
                            completeCallback.call(null, response, form)
                        }
                    }
                });
            });
        });
    };
    $('#pr_price').on('click', function (e) {
        e.preventDefault();
        const $calc = $('#form-calculator');
        const offsetTop = $calc.offset().top + $calc.innerHeight();
        $('html, body').animate({scrollTop: offsetTop}, 1000, function(){
            $('#budget_result_banner').slideDown("slow", function() {
                $('#go_to_top').slideDown();
            })

        });
    });
})(jQuery, window);

(function ($) {
    $.fn.inputShadow = function () {
        return $(this).each(function (parent_i, parent) {
            var $parent = $(parent);
            var $input = $parent.find('input, textarea, [contenteditable], select').filter((inputIndex, input) => {
                return !$(input).closest('[js-inputshadow]').not($parent).length;
            }).eq(0);
            var isToggle = $input.is(':checkbox, :radio');
            var isValidate = $input.data('validate') || false;
            var isRequired = $input.prop('required') || isValidate || false;
            var isContenteditable = $input.is('[contenteditable]');
            var errorRemoveEvent = $parent.data('error-remove') || 'input' || 'focus';
            var novalidate = ($input.data('novalidate') && !isValidate) || false;

            if (isContenteditable) {
                var $hiddenInput = $parent.find('textarea');
                if ( !$hiddenInput.length ) {
                    $hiddenInput = $('<textarea name="' + $input.attr('name') + '" />').appendTo($parent);
                }
                $hiddenInput.val($input[0].innerText.trim()).hide().prop({
                    disabled: $input.attr('disabled'),
                    required: $input.attr('required'),
                });
            }

            $parent.removeClass('is-focus is-filled').toggleClass('is-required', isRequired);
            $input.off('.input-shadow');

            if ($input.is('select')) {
                var $options = $input.find('option');
                var selectedVal;
                $input.on({
                    'update.input-shadow': function (e) {
                        isRequired = $input.prop('required');
                        $parent.toggleClass('is-required', isRequired);
                        $options = $input.find('option');
                        $input.trigger('changeSilent');
                    },
                    'invalid.input-shadow': function (e) {
                        $parent.addClass('is-invalid').removeClass('is-ok is-valid');
                    },
                    'valid.input-shadow': function (e) {
                        $parent.addClass('is-valid').removeClass('is-invalid');
                    },
                    'change.input-shadow changeSilent.input-shadow': function (e, notUser) {
                        if ($input.is(':disabled')) {
                            $parent.addClass('is-disabled');
                        }
                        else {
                            $parent.removeClass('is-disabled');
                        }

                        selectedVal = $options.filter(':selected').val();

                        if (selectedVal && selectedVal !== '' && selectedVal !== '0') {
                            $parent.addClass('is-filled');

                            if (!notUser && $parent.hasClass('is-error')) {
                                $parent.removeClass('is-error');
                            }
                        }
                        else {
                            $parent.removeClass('is-filled');

                            if (!notUser && !isRequired && $parent.hasClass('is-error')) {
                                $parent.removeClass('is-error');
                            }
                        }

                        if ( isValid($input) ) {
                            $parent.addClass('is-valid');
                            $input.data({valid: true}).trigger('valid');
                        }
                        else {
                            $parent.removeClass('is-ok is-valid');
                            $input.data({valid: false}).trigger('invalid');
                        }
                    }
                });
            }
            else if (isToggle) {
                var group = $input.data('fieldset');
                var $group = group ? $parent.parents('[js-inputShadow-fieldset][data-fieldset="'+ group +'"]').off('.input-shadow') : $();
                var $groupInputs = $group.length ? $group.find('input') : $();

                $input.on({
                    'update.input-shadow': function (e) {
                        isRequired = $input.prop('required');
                        $parent.toggleClass('is-required', isRequired);
                        $parent.add($input).toggleClass('is-checked', $input.prop('checked'));
                    },
                    'change.input-shadow changeSilent.input-shadow': function (e) {
                        $parent.add($input).toggleClass('is-checked', $input.prop('checked'));

                        if ($input.is(':disabled')) {
                            $parent.addClass('is-disabled');
                        }
                        else {
                            $parent.removeClass('is-disabled');
                        }

                        if ( isValid($input) ) {
                            $parent.removeClass('is-error');
                            $input.data({valid: true}).trigger('valid');
                        }
                        else {
                            $parent.addClass('is-error');
                            $input.data({valid: false}).trigger('invalid');
                        }
                    }
                });

                if ( $input.is(':radio') ) {
                    var name = $input.attr('name');
                    if ( !$groupInputs.length ) {
                        $groupInputs = $(`[name="${name}"][type="radio"]`).not($input);
                    }

                    $input.on({
                        'change.input-shadow changeSilent.input-shadow': function (e) {
                            $groupInputs.filter('.is-checked').trigger('changeSilent');
                            console.log($groupInputs)
                        }
                    });
                    $group.on({
                        'valid.input-shadow': function (e) {
                            $groupInputs.filter(`[name="${name}"]`).data({valid: true});
                        },
                        'invalid.input-shadow': function (e) {
                            $groupInputs.filter(`[name="${name}"]`).data({valid: false});
                        }
                    });
                }

                $group.on({
                    'valid.input-shadow invalid.input-shadow': function (e) {
                        if ( $groupInputs.filter(function (inputIndex, input) {return $groupInputs.eq(inputIndex).data('valid') === false}).length ) {
                            $group.addClass('is-error');
                        }
                        else {
                            $group.removeClass('is-error');
                        }
                    }
                });
            }
            else {
                var group = $parent.data('inputs-group');
                var $group = group ? $parent.parents('[js-inputShadow-group][data-inputs-group="'+ group +'"]') : $();
                var $groupInputs = $group.length ? $group.find('input') : $();

                $group.on({
                    'valid.input-shadow invalid.input-shadow': function (e) {
                        if ( $groupInputs.filter(function (inputIndex, input) {return $groupInputs.eq(inputIndex).data('valid') === false}).length ) {
                            $group.addClass('is-error');
                            $parent.removeClass('is-error');
                        }
                        else {
                            $group.removeClass('is-error');
                        }
                    }
                });

                $input.on({
                    'update.input-shadow': function (e) {
                        isRequired = $input.prop('required');
                        $parent.toggleClass('is-required', isRequired);
                    },
                    'invalid.input-shadow': function (e) {
                        $parent.addClass('is-invalid').removeClass('is-ok is-valid');
                    },
                    'valid.input-shadow': function (e) {
                        $parent.addClass('is-valid').removeClass('is-invalid');
                    },
                    'clear.input-shadow': function (e) {
                        // e.stopPropagation();
                        $parent.removeClass('is-error is-invalid is-valid');
                        $input.val(null).trigger('changeSilent');
                    },
                    'focus.input-shadow': function (e) {
                        $parent.addClass('is-focus');
                        if (errorRemoveEvent == 'focus') {
                            $parent.removeClass('is-error');
                        }
                        if ( $.fn.inputmask && $input.data('inputmask-showmaskonfocus') && $input.inputmask("hasMaskedValue") ) {
                            $parent.addClass('is-filled');
                        }
                    },
                    'blur.input-shadow': function (e) {
                        var $targetInput = isContenteditable ? $hiddenInput : $input;
                        $parent.removeClass('is-focus');

                        if ( isRequired && isValid($targetInput) ) {
                            $parent.addClass('is-valid').removeClass('is-invalid');
                            $targetInput.data({valid: true}).trigger('valid');
                        }
                        else if ( isRequired ) {
                            $parent.addClass('is-invalid').removeClass('is-ok is-valid');
                            $targetInput.data({valid: false}).trigger('invalid');
                        }
                    },
                    'keyup.input-shadow': function (e) {
                        if (isContenteditable) {
                            $input.trigger('changeSilent');
                        }
                    },
                    'animationstart.input-shadow': function (e) {
                        if ( e.originalEvent.animationName == 'is-input-autofilled' ) {
                            $parent.addClass('is-autofilled');
                        }
                        else if ( e.originalEvent.animationName == 'not-input-autofilled' ) {
                            $parent.removeClass('is-autofilled');
                        }
                    },
                    'input.input-shadow change.input-shadow changeSilent.input-shadow': function (e, notUser) {
                        // $parent.removeClass('is-autofilled');
                        if ($input.is(':disabled')) {
                            $parent.addClass('is-disabled');
                        }
                        else {
                            $parent.removeClass('is-disabled');
                        }

                        if ($input.val().length > 0 || (isContenteditable && $input[0].innerText.trim().length > 0) || ( $.fn.inputmask && $input.inputmask("unmaskedvalue").length > 0)) {
                            $parent.addClass('is-filled');
                            if ($parent.hasClass('is-error')) {
                                $parent.removeClass('is-error');
                            }
                        }
                        else if ( ($.fn.inputmask && !$input.inputmask("hasMaskedValue")) ) {
                            $parent.removeClass('is-filled');
                        }

                        if (e.type !== 'change' && !notUser) {
                            $parent.removeClass('is-valid is-invalid');
                        }

                        if (isContenteditable) {
                            $hiddenInput.val($input[0].innerText.trim());
                        }

                        if ( notUser && $.fn.inputmask && $input.is('[data-is-inputmask]') && $input.inputmask("unmaskedvalue").length == 0 ) {
                            $parent.removeClass('is-filled');
                        }
                    },
                    'maskIncomplete': function (e) {
                        if ( isRequired ) {
                            isValid($input);
                        }
                        // $input.inputValidate();
                        if ( $input.inputmask("unmaskedvalue").length == 0 ) {
                            $parent.removeClass('is-filled');
                        }
                    }
                });
            }

            function isValid ($input) {
                // return novalidate || (!isRequired || (isRequired && !$input[0].value)) ? true : $.isEmptyObject($input.inputValidate());
                // return novalidate || (!isRequired ? true : $.isEmptyObject($input.inputValidate(isToggle || !$input[0].value)));
                return novalidate || (!isRequired || isToggle ? true : $.isEmptyObject($input.inputValidate(!isToggle && !$input[0].value)));
            }

            $input.trigger('changeSilent', true);
        });
    };
})(jQuery);

(function(){

    'use strict';

    var Layer;
    var $document,
        $window,
        $body,
        $bodyWrapper,
        $layersDump,
        $overlay,
        overlayAllowed;

    var initialized,
        opened = [],
        bodyScroll,
        storage = {};

    function layerAlert({title, content, bg, options = {}}){
        return new Promise((resolve, reject) =>{
            var $layer = $(`
                 <div js-overlayer class="layer layer_overlay layer_alert ${bg ? `layer_alert_bg` : ''}" data-id="flash/error">
                    <div class="layer__inside">
                        <a js-close-layer class="layer-close" role="button" href="#">
                            <svg class="svg-icon svg-icon_times layer-close__icon" preserveAspectRatio="none"><use xlink:href="#sprite-icon-times"></use></svg>
                        </a>

                        ${title ? `
                            <div class="layer__header">
                                <div class="layer__header-figure" style="background-image: url('${bg ? `${bg}` : ''}')">
                                    <div class="layer__header-icon">
                                        <svg class="svg-icon svg-icon_tick" preserveAspectRatio="none"><use xlink:href="#sprite-icon-tick"></use></svg>
                                    </div>
                                </div>
                                
                                <div class="layer__title title-h2">${title}</div>
                            </div>
                        ` : ''}
                        ${content ? `
                         <div class="layer__content">
                            <div class="layer__description">${content}</div>
                        </div>
                        ` : ''}
                    </div>
                </div>
            `);
            var layer = new Layer($layer[0], {
                isOverlayer: true,
                afterOpen: ($layer, layerData) => {
                    $layer.find('[js-close-layer]').focus();
                    options.afterOpen && options.afterOpen.call($layer, layerData);
                    if ( options.closeOthers ) {
                        opened.forEach((openItem, openIndex) => {
                            if ( openItem.id !== 'flash/error' ) {
                                openItem.close();
                            }
                        });
                    }
                },
                afterClose: ($layer, layerData) => {
                    $layer.remove();
                    resolve(layer);
                    options.afterClose && options.afterClose.call($layer, layerData);
                }
            });
            layer.open();
        });
    }

    function layerConfirm({title = 'Подтвердите действие', content, options = {}}){
        const settings = {
            cancel: 'Нет',
            ok: 'Хорошо',
            ...options,
        };
        return new Promise((resolve, reject) =>{
            var $layer = $(`
                <div js-overlayer class="layer layer_overlay layer_confirm" data-id="confirm">
                    <div class="layer__inside">
                        <a class="layer-close" role="button" href="#"></a>
                        ${title ? `
                            <div class="layer__header">
                                <div class="layer__title">${title}</div>
                            </div>
                        ` : ''}
                        ${content ? `
                            <div class="layer__content">
                                ${content}
                            </div>
                        ` : ''}
                        <div class="layer__footer">
                            <div class="button-group button-group_same button-group_list_m">
                                <div class="button-group__side">
                                    <a js-close-layer href="#" class="button button_link button_small "><span class="button__content"><span class="button__icon button__icon_cross "></span><span class="button__title">${ settings.cancel }</span></span></a>
                                </div>
                                <div class="button-group__main button-group__main_content-end">
                                    <button js-confirm-yes type="button" class="button button_full_m "><span class="button__content"><span class="button__title">${ settings.ok }</span></span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `);
            var layer = new Layer($layer[0], {
                isOverlayer: true,
                beforeOpen: ($layer, layerData) => {
                    $layer.find('[js-confirm-yes]').on({
                        'click.confirm': (e) => {
                            e.preventDefault();
                            resolve();
                            layer.close();
                        }
                    });
                },
                afterOpen: ($layer, layerData) => {
                    $layer.find('[js-close-layer]').focus();
                    settings.afterOpen && settings.afterOpen.call($layer, layerData);
                    if ( settings.closeOthers ) {
                        opened.forEach((openItem, openIndex) => {
                            if ( openItem.id !== 'confirm' ) {
                                openItem.close();
                            }
                        });
                    }
                },
                beforeClose: ($layer, layerData) => {
                    reject();
                },
                afterClose: ($layer, layerData) => {
                    $layer.remove();
                    settings.afterClose && settings.afterClose.call($layer, layerData);
                },
            });
            layer.open();
        });
    }

    function initialize(){
        if(initialized) return;
        initialized = true;

        $document = $(document);
        $window = $(window);
        $body = $('body');
        $bodyWrapper = $('.body__wrapper');
        $layersDump = $('[js-layers-dump]');

        overlayAllowed = true;

        if ( !$layersDump.length ) {
            $layersDump = $('<div js-layers-dump style="display: none;" />').appendTo($body);
        }

        if(overlayAllowed){
            $overlay = $('<div class="body__overlay"></div>').appendTo($body);

            $overlay.on('click', function(e){
                e.preventDefault();
                if(opened && !opened[opened.length - 1].options.disableOverlayClose){
                    opened[opened.length - 1].close();
                }
            });
        }


        $document.on('click', '[js-open-layer]', function(e){
            e.preventDefault();
            e.stopPropagation();
            open($(this).attr('js-open-layer'));
        });

        $document.on('click', '[js-toggle-layer]', function(e){
            e.preventDefault();
            e.stopPropagation();
            toggle($(this).attr('js-toggle-layer'));
        });
    }

    function findLayer(id){
        var layer = storage[id];
        if(!layer){
            layer = new Layer($('.layer[data-id="' + id + '"]'));
            storage[layer.id] = layer;
        }
        return layer;
    }

    function open(id, data){
        return findLayer(id).open(data)
    }


    function toggle(id){
        var layer = findLayer(id);
        if(layer.opened){
            layer.close()
        }else{
            layer.open();
        }
    }

    function close(id, data, delay){
        if(!id && opened.length){
            return findLayer(opened[opened.length - 1].id).close(delay, data)
        }
        else if(id){
            return findLayer(id).close(delay, data)
        }
    }

    function showOverlay(){
        if(overlayAllowed){
            $overlay.addClass('is-opened');
        }
    }

    function hideOverlay(){
        if(overlayAllowed){
            $overlay.removeClass('is-opened');
        }
    }

    function lockBody(){
        $bodyWrapper.css('top', -(bodyScroll = $document.scrollTop())).addClass('is-locked');
    }

    function unlockBody(){
        $bodyWrapper.css('top', 'auto').removeClass('is-locked');
        $document.scrollTop(bodyScroll);
    }

    function hideBody(isOverlayer){
        $bodyWrapper.addClass(isOverlayer ? 'is-overlay' : 'is-hide').removeClass(isOverlayer ? 'is-hide' : '');
    }

    function showBody(isOverlayer){
        $bodyWrapper.removeClass(isOverlayer ? 'is-overlay is-hide' : 'is-hide');
    }

    Layer = function($layer, options){
        options = $.extend(
            {
                disableOverlayClose: ($layer.dataset && $layer.dataset.disableOverlayClose) || false,
            },
            options || {}
        );

        $.extend(this, {
            options: options,
            id: null,
            initialized: false,
            opened: false,
            $origin: null,
            $layer: null
        });

        this.initialize($layer);
    };


    $.extend(Layer.prototype, {
        initialize: function($layer){
            if(this.initialized) return;
            this.initialized = true;
            $layer = $($layer);
            if(!$layer.length){
                throw new Error('Layer not found');
            }

            this.$origin = this.$layer = (this.options.detach == false ? $layer.appendTo($layersDump) : $layer.detach());
            this.id = $layer.data('id');

            $layer.addClass('is-initialized');

            $layer.on('layer-close', function(){
                this.close();
            }.bind(this));

            $layer.on('click', '.layer-close, .layer-back, [js-close-layer]', function(e){
                if(!$(e.currentTarget).attr('href') || $(e.currentTarget).attr('href') == '#'){
                    e.preventDefault();
                    this.close($(e.currentTarget).data('close-delay') || 0);
                }
            }.bind(this));
        },
        open: function(data){
            return new Promise((resolve, reject) =>{
                if ( this.opened && !this.$layer.hasClass('is-faded') ) {
                    resolve(this);
                    return;
                }

                if(this.options.clone){
                    this.$layer = this.$origin.clone(true, true);
                }

                var $layer = this.$layer,
                    $header = $layer.find('.layer-header'),
                    top = opened[opened.length - 1];
                $layer.css('top', 0);

                $window.trigger('layerOpen', [this.$layer, this.id]);
                if(this.options.beforeOpen){
                    this.options.beforeOpen.call(this, this.$layer, data);
                }

                if(opened.length){
                    top.scrollTop = $window.scrollTop();
                    // top.scrollTop = Math.abs(top.$layer.offset().top);
                    top.$layer.css('top', -top.scrollTop);
                    opened.forEach(function(layer){
                        layer.$layer.addClass('is-faded');
                    });
                }
                else{
                    lockBody();
                }

                opened.push(this);
                this.opened = true;


                if(this.options.isOverlayer){
                    showOverlay();
                    $overlay.removeClass('is-complete');
                }else{
                    hideOverlay();
                    hideBody();
                }

                setTimeout(function(){
                    $body.append($layer.addClass('is-animating'));

                    if(this.options.aside){
                        $layer.addClass('is-aside');
                    }

                    $layer[0].offsetHeight;
                    $layer.addClass('is-opened').removeClass('is-faded');

                    $layer.one('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function(e){
                        e.stopPropagation();
                        e.stopImmediatePropagation();
                        $layer.removeClass('is-animating');

                        if(this.options.isOverlayer){
                            $overlay.addClass('is-complete');
                        }
                    }.bind(this));

                    if($header.length){
                        $layer.css('padding-top', $header.outerHeight());
                    }

                    $document.scrollTop(0);

                    // if ( $.fn.inputmask ) {
                    //     $layer.find('[data-inputmask]').inputmask();
                    // }

                    if(this.options.afterOpen){
                        this.options.afterOpen.call(this, this.$layer, data);
                    }


                    if (!this.options.disableOverlayClose) {
                        $document.on('keyup.layer-close-'+this.id, (e) => {
                            if ( e.keyCode == 27 ) {
                                // ESC
                                this.close();
                            }
                        });
                    }
                    $window.trigger('layerOpened', [this.$layer, this.id]);

                    resolve(this);
                }.bind(this), 10);

            });
        },

        close: function(delay, data){
            return new Promise((resolve, reject) =>{

                opened = opened.filter(function(layer){
                    return layer !== this;
                }, this);
                var $layer = this.$layer;
                $layer.css('top', -$window.scrollTop());
                $layer.addClass('is-closing');

                setTimeout(function(){
                    var top = opened[opened.length - 1];

                    $window.trigger('layerClose', [this.$layer, this.id]);
                    if(this.options.beforeClose){
                        this.options.beforeClose.call(this, $layer, data, top);
                    }
                    $document.off('.layer-close-'+this.id);

                    if(top && top.$layer.hasClass('is-faded')){
                        top.$layer.css('top', 0).removeClass('is-faded');
                        $window.scrollTop(top.scrollTop);
                    }

                    $layer.addClass('is-animating').removeClass('is-opened');

                    if(!opened.length || this.options.isOverlayer){
                        showBody();
                    }

                    if(top && this.options.isOverlayer){
                        showOverlay();
                    }else if(this.options.isOverlayer){
                        hideOverlay();
                    }

                    setTimeout(function(){
                        $layer.removeClass('is-animating').removeClass('is-closing');
                        if ( this.options.detach == false ) {
                            $layer.appendTo($layersDump);
                        }
                        else {
                            $layer.detach();
                        }
                        this.opened = false;

                        if(!opened.length){
                            unlockBody();
                        }

                        if(this.options.afterClose){
                            this.options.afterClose.call(this, $layer, data, top);
                        }

                        resolve(this);
                        $layer.trigger('layer-closed', this);
                        $window.trigger('layerClosed', [this.$layer, this.id]);
                    }.bind(this), 300);

                }.bind(this), delay || 0);

            });
        }
    });

    $.extend(Layer, {
        alert: layerAlert,
        confirm: layerConfirm,
        open: open,
        close: close,
        toggle: toggle,
        closeAll: function(){
            opened.forEach(function(open){
                open.close();
            });
        }
    });


    $(function(){
        initialize();
    });

    window.Layer = Layer;

    $.fn.layer = function(options){
        setTimeout(function(){
            this.each(function(){
                var $layer = $(this);
                var layer = new Layer(this, options);
                storage[layer.id] = layer;
                $layer.off('.layer').on({
                    'openLayer.layer': (e, eData) => {
                        layer.open(eData);
                    },
                });
            });
        }.bind(this), 10);
    };
}());

app.bind('default', function(context) {
    const $window = $(window);
    const $mobileSlider = $('.js-mobile-only-slider', context);

    if ($window.width() < 501) {
        $mobileSlider.addClass('owl-carousel').owlCarousel({
            items:1,
            autoWidth:true,
        });
    }
});

!function(){
    function showError(message){
        Layer.alert({content: message});
    }

    function internalError(message){
        showError(message || 'Произошел технический сбой');
    }

    app.errorHandler = function(xhr){
        app.processError(xhr);
    };

    app.processError = function(xhr, {query, request} = {}){
        return new Promise((resolve, reject) =>{
            if ( xhr.statusText == 'abort' ) {
                reject({error: 'abort'});
            }

            const error = xhr.responseJSON.error;

            if(400 === xhr.status){
                if(error.query){
                    if(query){
                        query(error.query);
                    }else{
                        internalError(error.message)
                    }
                }else if(error.request){
                    if(request){
                        request(error.request);
                    }else{
                        internalError(error.message)
                    }
                }else{
                    internalError(error.message)
                }

            }else if(401 === xhr.status){

            }else if([403, 404].includes(xhr.status)){
                const error = xhr.responseJSON.error;
                internalError(error.message);

            }else{
                internalError();
            }

            resolve(error);
        }).catch((response) => {
            console.log(response);
        });
    };
}();

!function () {
    let resizeAF = null;
    let resizeTimer = null;

    app.bind('default resize window-resize', function (context) {
        if ( resizeAF ) {
            clearTimeout(resizeTimer);
            cancelAnimationFrame(resizeAF);
        }
        const $window = $(window);
        let windowWidth;
        let windowHeight;
        let bodyHeight;
        let windowWidthWas;
        let windowHeightWas;
        let bodyHeightWas;
        let isBodyResized = false;

        const resizeCallback = (timestamp) => {
            windowWidth = window.innerWidth;
            windowHeight = window.innerHeight;
            bodyHeight = document.body.scrollHeight;
            if ( windowWidth != windowWidthWas || windowHeight != windowHeightWas || bodyHeight != bodyHeightWas) {
                windowWidthWas = windowWidth;
                windowHeightWas = windowHeight;

                isBodyResized = bodyHeight != bodyHeightWas;
                bodyHeightWas = bodyHeight;

                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => {
                    $window.trigger('windowResized', {
                        windowWidth,
                        windowHeight,
                        bodyHeight,
                        isBodyResized,
                    });
                }, 250);
            }

            resizeAF = requestAnimationFrame(resizeCallback);
        };
        resizeAF = requestAnimationFrame(resizeCallback);
    }, -500);
}();

(function ($) {
    const tipOptions = {
        position: {
            effect: false,
            my: 'top center',
            at: 'bottom center',
            adjust: {
                scroll: false,
                method: 'shift flipinvert',
                x: 0,
                y: 11
            }
        },
        show: {
            solo: true,
            event: 'click',
        },
        hide: {
            fixed: true,
            delay: 0,
            event: 'unfocus',
        },
        style: {
            classes: 'qtip-selo',
            tip: false
        },
        events: {
            show(e, api) {
                const $field = api.elements.target.closest('.field');
                const tipType = $field.data('tip-type');
                if (tipType === 'full') {
                    api.elements.tooltip.css({
                        minWidth: $field.length ? $field[0].getBoundingClientRect().width : api.elements.target[0].getBoundingClientRect().width,
                    });
                } else {
                    api.elements.tooltip.css({
                        width: $field.length ? $field[0].getBoundingClientRect().width : api.elements.target[0].getBoundingClientRect().width,
                        left: '50%',
                    });
                }
                api.elements.target.trigger('on-show.selo');
            },
            move(e, api) {
                if ( api.position.my.y === 'top' ) {
                    api.tooltip.removeClass('qtip-pos-bottom').addClass('qtip-pos-top');
                }
                else if ( api.position.my.y === 'bottom' ) {
                    api.tooltip.removeClass('qtip-pos-top').addClass('qtip-pos-bottom');
                }
            },
            hide(e, api) {
                api.elements.target.trigger('on-hide.selo');
            },
            render(e, api) {
                api.elements.target.trigger('on-render.selo');
            },
        }
    };

    function getSelectedInfo ($items, value, options) {
        let title = '';
        let $selectedItems = $();

        if ( Array.isArray(value) ) {
            $selectedItems = $items.filter((itemIndex, item) => value.indexOf(item.dataset.value) > -1);
            value = value.map((item) => item.toString());
            if ( $selectedItems.length > options.count && !options.isTags ) {
                title = options.countTitle($selectedItems.length, $items.length);
            }
            else if ( $selectedItems.length > options.count && options.isTags ) {
                title = `<span class="field-options-tags">${ $selectedItems.toArray().map((item) => options.tagTpl(item)).join('') }</span>`;
            }
            else {
                title = $selectedItems.toArray().map((item) => item.dataset.title).join(', ');
            }
        }
        else if ( value ) {
            $selectedItems = $items.filter((itemIndex, item) => item.dataset.value === value);
            value = value.toString();
            title = $selectedItems.data('title') || $selectedItems.html();
            if ( !options.isTitleInput && options.titleTpl ) {
                title = options.titleTpl($selectedItems[0]);
            }
        }

        return {
            selectedCount: $selectedItems.length,
            allCount: $items.length,
            title,
        };
    }

    function filterOptionsElementsByValue ($items, value, options = {hideDefault: false}) {
        if ( !value ) return $items.show();
        let $matching = $items.filter((itemIndex, item) => item.dataset.title.toLowerCase().indexOf(value.toLowerCase()) > -1);

        if ( options.hideDefault ) {
            $matching = $matching.not('.is-default');
        }

        $items.not($matching.css('display', '')).hide();
        return $matching;
    }

    function createExtraOptionsElements (extraOptions = [], options = {itemTpl: (item, options) => '', defaultValue: '', isMultiple: false}) {
        return $(extraOptions.map((item) => {
            return options.itemTpl(item, options).trim();
        }).join(''));
    }

    function createOptionsElements ($select, options = {itemTpl: (item, options) => '', defaultValue: '', isMultiple: false}) {
        return $($select.children().not('[data-extra-option]').toArray().map((item) => {
            return options.itemTpl(item, options).trim();
        }).join(''));
    }

    function selectItemsByValue($items, value) {
        $items.filter('.is-selected').removeClass('is-selected');

        if ( Array.isArray(value) ) {
            value = value.map((item) => item.toString());
            $items.filter((itemIndex, item) => value.indexOf(item.dataset.value) > -1).addClass('is-selected');
        }
        else if ( value ) {
            value = value.toString();
            $items.filter((itemIndex, item) => item.dataset.value == value).addClass('is-selected');
        }
        else {
            $items.filter('.is-default').addClass('is-selected');
        }
    };

    $.fn.selo = function (options) {
        const app = window.app;
        const $bodyWrapper = $('.body__wrapper');

        return this.each((selectIndex, select) => {
            const $select = $(select);
            if ( $select.data('selo-inited') ) return;
            const $field = $select.closest('[js-selo-field]');
            const $title = $field.find('[js-selo-title]');
            const $container = $field.find('[js-selo-container]');
            const settings = $.extend({}, $.selo.defaults, options, $select.data('selo-settings'));
            const isTitleInput = settings.isTitleInput = $title.is(':input');
            const isMultiple = settings.isMultiple = !!$select.attr('multiple');
            const isPredictiveSearch = settings.isPredictiveSearch;
            const defaultValue = settings.defaultValue;
            const $optionsContainer = $(`<div js-selo-options-container class="field-options ${ settings.optionsMod.modNormalizer('field-options') }" />`);
            const $optionsList = $('<div js-scrollbar js-selo-options-list class="field-options__list" />').appendTo($optionsContainer);
            let $optionsItems = createOptionsElements($select, settings).appendTo($optionsList);
            const $notFound = $(settings.notFountTpl(settings.notFoundTitle));
            let $extraOptionsList = $();
            let $extraOptionsItems = $();
            let $searchInput = null;
            let tipApi = null;
            let isSearching = false;
            let isOpen = false;
            let isFocus = false;

            const toggleValue = function (value) {
                if ( value == null ) return;
                const currentValue = $select.val();
                if ( isMultiple && currentValue ) {
                    // Если есть значение в мультиселекте
                    if ( currentValue.indexOf(value) > -1 ) {
                        currentValue.splice(currentValue.indexOf(value), 1);
                    }
                    else {
                        currentValue.push(value);
                    }
                    $select.val(currentValue).trigger('change');
                }
                else {
                    $select.val(value).trigger('change');
                }
            };

            $field.off('.selo');
            $title.off('.selo');
            $select.off('.selo');
            $container.off('.selo');

            if ( isMultiple ) {
                settings.hideDefault = true;
            }

            if ( settings.hideDefault ) {
                $optionsContainer.addClass('field-options_hide-default');
            }

            if ( isMultiple ) {
                $optionsContainer.addClass('field-options_multiple');
            }
            else {
                $optionsContainer.addClass('field-options_single');
            }

            if ( settings.isTags ) {
                $field.addClass('is-selo-tags');
            }

            if ( isTitleInput || settings.isSearch ) {
                $notFound.appendTo($optionsList);
            }

            // Если дополниельные элементы списка
            if ( Array.isArray(settings.extraOptions) && settings.extraOptions.length ) {
                $extraOptionsList = $('<div js-selo-extra-options-list class="field-options__list field-options__list_extra" />').appendTo($optionsContainer);
                $extraOptionsItems = createExtraOptionsElements(settings.extraOptions, {defaultValue, isMultiple, extraItemTpl: settings.extraItemTpl}).appendTo($extraOptionsList);
                $(settings.extraOptions.map((option) => `<option data-extra-option="true" value="${ option.value }">${ option.title }</option>`).join('')).appendTo($select);

                // Подключаем возможность выбора для экстра элементов
                $extraOptionsItems.off('.selo').on({
                    'click.selo select.selo': (e) => {
                        toggleValue(e.currentTarget.dataset.value);
                        $select.trigger('hide.selo');
                    },
                });
            }

            // Активируем скрол
            app && app.use('scrollbar', $optionsContainer);

            // Подключаем возможность выбора для элементов списка
            $optionsItems.off('.selo').on({
                'click.selo select.selo': (e) => {
                    toggleValue(e.currentTarget.dataset.value);
                },
            });

            // Если заголовок — инпут, то подключаем поиск
            if ( isTitleInput ) {
                $searchInput = $title;
            }
            else if ( settings.isSearch ) {
                const $searchContainer = $(`
                    <div class="field-options__search">
                        <label js-inputshadow class="field field_selo-search">
                            <span class="field__main">
                                <span class="field__indicator"></span>
                                <span js-selo-options-search-clear class="field__icon field__icon_type_action field__icon_action_clear field__icon_cross"></span>
                                <input class="field-input field__input" type="text" placeholder="Поиск значений">
                            </span>
                        </label>
                    </div>
                `).prependTo($optionsContainer);
                const $searchClear = $searchContainer.find('[js-selo-options-search-clear]');
                $searchInput = $searchContainer.find('input');

                app && app.use('inputs', $searchContainer);

                $searchClear.on({
                    'click.selo.selo-search': (e) => {
                        $searchInput.val(null).trigger('input');
                    },
                });

                $select.on({
                    'after-change-selo.selo.selo-search': (e) => {
                        if ( isOpen ) {
                            $searchInput.trigger('focus');
                        }
                    },
                });

                $field.on({
                    'on-show.selo.selo-search': (e) => {
                        requestAnimationFrame(() => {
                            $searchInput.trigger('focus');
                        });
                    },
                    'on-hide.selo.selo-search': (e) => {},
                });
            }
            if ( isTitleInput || settings.isSearch ) {
                let titleValueWas = '';

                $searchInput.on({
                    'focus.selo': (e) => {
                        isFocus = true;
                        titleValueWas = $searchInput.val();
                    },
                    'blur.selo': (e) => {
                        isFocus = false;
                    },
                    'input.selo': (e) => {
                        if ( !isSearching && $searchInput.val() !== titleValueWas ) {
                            isSearching = true;
                        }
                        if ( isSearching ) {
                            const $foundItems = filterOptionsElementsByValue($optionsItems, $searchInput.val(), {hideDefault: settings.hideDefault});
                            $notFound.toggleClass('is-visible', $foundItems.length === 0 );
                            $optionsList.trigger('update.scrollbar');
                            tipApi.reposition();
                        }
                    },
                    'keyup.selo': (e) => {
                        switch (e.keyCode) {
                            case 13: // Enter
                                if ( $searchInput.val().length ) {
                                    filterOptionsElementsByValue($optionsItems, $searchInput.val(), {hideDefault: settings.hideDefault}).eq(0).trigger('select.selo');
                                    $optionsList.trigger('update.scrollbar');
                                    $searchInput.trigger('blur');
                                }
                                break;
                        }
                    },
                    'cancel-search.selo': (e, payload = {reset: false}) => {
                        if ( !isSearching ) return;
                        $notFound.removeClass('is-visible');
                        if ( isMultiple ) {
                            $searchInput.val(null).trigger('change');
                        }
                        else {
                            $searchInput.val(titleValueWas).trigger('change');
                        }
                        setTimeout(() => {
                            filterOptionsElementsByValue($optionsItems, null);
                            $optionsList.trigger('update.scrollbar');
                        }, 100)
                        isSearching = false;
                    },
                });
            }

            if ( !isTitleInput && window.deviceType.mobile ) {
                $field.off('.selo-focus-fix').on('click.selo-focus-fix', (e) => {
                    e.preventDefault();
                });
            }

            if ( settings.isTags ) {
                $title.on('click.selo', '[js-selo-option-tag]', (e) => {
                    e.preventDefault();
                    if ( isOpen ) {
                        e.stopPropagation();
                    }
                });
                $title.on('click.selo', '[js-selo-option-tag-remove]', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const $tag = $(e.target).closest('[js-selo-option-tag]');

                    $select.trigger('unselect', {value: $tag.attr('data-value')});
                });
            }

            $select.on({
                'set-value.selo': (e, payload = {}) => {
                    const newValue = payload.value;
                    if ( newValue === undefined ) return;
                    if ( isSearching && !isMultiple ) {
                        $title.trigger('cancel-search.selo');
                    }
                    const $items = $optionsItems.add($extraOptionsItems);
                    const selectedInfo = getSelectedInfo($items, newValue, settings);
                    selectItemsByValue($items, newValue);
                    if ( isTitleInput && !isMultiple ) {
                        app.triggerEvent('change', $title.val(selectedInfo.title));
                    }
                    else if ( !isTitleInput ) {
                        if ( newValue === defaultValue || newValue == null ) {
                            $title.html($title.attr('placeholder') || '');
                        }
                        else {
                            $title.html(selectedInfo.title);
                        }
                    }

                    if ( isMultiple && tipApi ) {
                        tipApi.reposition();
                    }
                    else {
                        $select.trigger('hide.selo');
                    }

                    if ( $searchInput && isOpen ) {
                        $searchInput.trigger('focus');
                    }

                    requestAnimationFrame(() => {
                        if ( $searchInput ) {
                            $title.trigger('changeSilent');
                        }
                        $select.trigger('after-change-selo');
                    });
                },
                'unselect.selo': (e, payload = {value: null}) => {
                    toggleValue(payload.value);
                },
                'change.selo changeSilent.selo': (e) => {
                    $select.trigger('set-value', {value: $select.val()});
                },
                'hide.selo': (e) => {
                    if ( tipApi ) {
                        tipApi.hide();
                    }
                },
                'show.selo': (e) => {
                    if ( tipApi ) {
                        tipApi.show();
                    }
                },
                'disable.selo': (e) => {
                    if ( tipApi ) {
                        tipApi.disable();
                    }
                },
                'enable.selo': (e) => {
                    if ( tipApi ) {
                        tipApi.enable();
                    }
                },
                'destroy.selo': (e) => {
                    app.use('scrollbar-destroy', $optionsContainer);
                    if ( tipApi ) {
                        tipApi.destroy();
                    }
                },
                'update.selo': (e) => {
                    if ( isPredictiveSearch ) {
                        $optionsList.empty();
                        $optionsItems = createOptionsElements($select, {defaultValue, isMultiple, itemTpl: settings.itemTpl}).appendTo($optionsList);

                        const $foundItems = filterOptionsElementsByValue($optionsItems, null, {hideDefault: settings.hideDefault});
                        if ( !$foundItems.length ) {
                            $select.trigger('hide.selo').trigger('disable.selo');
                        }
                        else if ( isFocus ) {
                            $select.trigger('enable.selo').trigger('show.selo');
                        }
                        else {
                            $select.trigger('enable.selo');
                        }
                    }
                },
            }).trigger('set-value', {value: $select.val()});

            $field.on({
                'on-show.selo': (e) => {
                    isOpen = true;
                    $field.addClass('is-selo-opened');
                    $optionsList.trigger('update.scrollbar');
                    if ( !isTitleInput ) {
                        $field.off('.selo-hide').on({
                            'click.selo-hide': (e) => {
                                if ( isOpen ) {
                                    e.preventDefault();
                                    requestAnimationFrame(() => {
                                        $select.trigger('hide.selo');
                                    });
                                }
                            },
                        });
                    }
                },
                'on-hide.selo': (e) => {
                    isOpen = false;
                    $field.off('.selo-hide');
                    if ( $searchInput ) {
                        $searchInput.trigger('cancel-search.selo');
                    }
                    $field.removeClass('is-selo-opened');
                },
                'on-render.selo': (e) => {},
            });

            tipApi = $field.qtip($.extend(true, {}, tipOptions, {
                position: {
                    viewport: $bodyWrapper,
                    target: $container,
                },
                content: {
                    text: $optionsContainer,
                },
                style: {
                    classes: tipOptions.style.classes + ' ' + settings.mod
                },
            }, $container.data('qtip-options') )).qtip('api');

            $select.data('selo-inited', true);

            if ( isPredictiveSearch ) {
                $select.trigger('disable.selo');
            }
        });
    };

    $.selo = {};
    $.selo.defaults = {
        defaultValue: '',
        hideDefault: true,
        count: Infinity,
        countTitle: (selected, all) => `Выбрано: <b>${selected}</b>`,
        optionsMod: '',
        extraOptions: [],
        notFoundTitle: 'Нет совпадений',
        isPredictiveSearch: false,
        isTags: false,
        titleTpl: null,
        isSearch: false,
        notFountTpl: (title) => `
            <div js-selo-option-notfound class="field-options__item field-options__item_notfound field-options-item field-options-item_notfound">
                <div class="field-options-item__title">${ title }</div>
            </div>
        `,
        tagTpl: (item) => `
            <span js-selo-option-tag data-value="${item.dataset.value}" class="field-options-tags__item field-options-tag ${ (item.dataset.mod || '').modNormalizer('field-options-tag') }">
                <span class="field-options-tag__icon"></span>
                <span class="field-options-tag__title">${item.dataset.title}</span>
                <span js-selo-option-tag-remove data-value="${item.dataset.value}" class="field-options-tag__action field-options-tag__action_remove"></span>
            </span>
        `,
        itemTpl: (item, options) => {
            const itemData = item.dataset || {};
            itemData.title = itemData.title || item.innerHTML;
            itemData.value = item.value;

            return `
                <div js-selo-option class="field-options__item field-options-item ${item.value === options.defaultValue ? 'is-default' : ''}" ${ Object.keys(itemData).map((dataKey) => `data-${dataKey}=${JSON.stringify(itemData[dataKey])}`).join('') }>
                    <div class="field-options-item__title">${ itemData.title }</div>
                </div>
            `
        },
        extraItemTpl: (item, options) => `
            <div js-selo-option class="field-options__item field-options__item_extra ${item.value === options.defaultValue ? 'is-default' : ''}" data-value="${ item.value }" data-title="${ item.title }">
                <div class="field-options__item-title">${ item.title }</div>
            </div>
        `,
    };
})(jQuery);

(function($){
    var $HB;
    var $panels = $();

    $.fn.tabby = function (options) {
        var settings = $.extend({}, {
            panels: '[js-tabby-panel]',
            openFirst: true
        }, options);
        var $tabs = $(this);
        $panels = $panels.add( $(settings.panels) );

        return $tabs.each(function (i, tab) {
            var $tab = $(tab);
            var rel = $tab.data('tabby-rel') || undefined;
            var isLabel = $tab.is('label');
            var isSelect = $tab.is('select');
            var scroll = $tab.data('tabby-scroll');
            var data = isSelect ? $tab.find(':selected').data('tabby').split(':') : $tab.data('tabby') ? $tab.data('tabby').split(':') : undefined;
            if ( !data ) return;
            var $scroll = scroll ? ( scroll == 'self' || scroll == true ? $tab : scroll == 'parent' ? $tab.parent() : scroll.length ? $(scroll) : $() ) : $();
            var hasPanel = getPanels($panels, data).length;
            scroll = $scroll.length;

            if ( !hasPanel ) {
                $tab.addClass('is-broken');
            }

            $tab.off('.tabby').on({
                'click.tabby openTab.tabby': function (e, eData) {
                    (!isLabel || !isSelect) && e.preventDefault();

                    if ( e.type == 'click' ) {
                        if ( $tab.hasClass('is-open') ) {
                            if ( $tab.data('tabby-selfclose') ) {
                                $tab.removeClass('is-open');
                                getPanels($panels, data)[1].removeClass('is-open');
                            }
                            return;
                        }
                        if ( rel ) {
                            rel.forEach(function (_rel) {
                                getTabs($tabs, _rel.split(':'))[1].trigger('openTab');
                            });
                        }
                    }
                    else {
                        e.stopPropagation();
                    }

                    if ( !hasPanel || (!data && !isSelect) ) {
                        $tab.addClass('is-broken');
                        return;
                    }
                    else {
                        var $tabs_filtered = getTabs($tabs, data);
                        $tabs_filtered[0].removeClass('is-open');
                        $tabs_filtered[1].not('select').addClass('is-open');
                        $tabs_filtered[1].filter('select').trigger('tabSelect', {tabData: data});

                        var $tab_panels = getPanels($panels, data);
                        $tab_panels[0].removeClass('is-open');
                        $tab_panels[1].addClass('is-open');

                        $tab.trigger('tabChanged', {
                            panel: $tab_panels[1].trigger('tabChanged', {
                                tab: $tab,
                                otherPanels: $tab_panels[0].not($tab_panels[1])
                            })
                        });

                        if ( scroll && $HB && !(eData && eData.scroll == false) ) {
                            $HB.not(':animated').animate({scrollTop: $scroll.offset().top}, 300);
                        }
                    }
                },
                'closeTab.tabby': function (e, eData) {
                    e.stopPropagation();
                    var $tab_panels = getPanels($panels, data);
                    $tab.removeClass('is-open');
                    $tab_panels[1].removeClass('is-open');
                    $tab.trigger('tabClosed', {
                        panel: $tab_panels[1].trigger('tabClosed', {
                            tab: $tab,
                            otherPanels: $tab_panels[0].not($tab_panels[1])
                        })
                    });
                }
            });

            if ( isLabel ) {
                var $input = $tab.attr('for') ? $('input#'+ $tab.attr('for')) : $tab.find('input');
                if ( $input.length ) {
                    $tab.off('click.tabby');
                    $input.off('.tabby').on({
                        'change.tabby': function (e) {
                            if ( $input.prop('checked') ) {
                                $tab.trigger('openTab');
                            }
                            else {
                                $tab.trigger('closeTab');
                            }
                        }
                    });
                }
            }

            if ( isSelect ) {
                $tab.off('click.tabby').on({
                    'change.tabby changeTabby.tabby': function (e, eData) {
                        e.stopPropagation();
                        data = $tab.find(':selected').data('tabby');
                        if ( !data ) {
                            data = $tab.data('tabby');
                            if ( !data ) return;

                            data = data.split(':');
                            $tab.trigger('closeTab');
                            return;
                        }

                        data = $tab.find(':selected').data('tabby');
                        $tab.data('tabby', data);
                        data = data.split(':');
                        $tab.trigger('openTab');
                    },
                    'openTab.tabby': function (e, eData) {
                        e.stopPropagation();
                        $tab.trigger('updateSelect');
                    },
                    'updateSelect.tabby': function (e, eData) {
                        e.stopPropagation();
                    },
                    'tabSelect.tabby': function (e, eData) {
                        e.stopPropagation();
                        if ( eData && eData.tabData ) {
                            $tab.val($tab.find('[data-tabby]').filter(function (optionIndex, option) {
                                return $(option).data('tabby').split(':')[1] == eData.tabData[1];
                            }).val());
                            $tab.trigger('silentChange');
                        }
                    },
                });

                if ( $tab.hasClass('is-open') ) {
                    $tab.trigger('changeTabby');
                }
            }

            if ( (!isLabel && $tab.hasClass('is-open')) || (isLabel && $input.prop('checked')) ) {
                $tab.trigger('openTab', {scroll: false});
            }
            else if ( $tab.hasClass('is-open') ) {
                $tab.trigger('closeTab');
            }

        });
    };

    function getTabs ($tabs, data) {
        var $tabs_filtered = $tabs.filter(function (i, panel) {
            var $tab = $tabs.eq(i);
            if ( $tab.is('select') ) {
                return $tab.find('[data-tabby]').filter(function (optionIndex, option) {
                    return $(option).data('tabby').split(':')[0] == data[0];
                }).length > 0;
            }
            return $tab.data('tabby') && $tab.data('tabby').split(':')[0] == data[0];
        });
        return [$tabs_filtered, $tabs_filtered.filter(function (i, panel) {
            var $tab = $tabs_filtered.eq(i);
            if ( $tab.is('select') ) {
                return $tab.find('[data-tabby]').filter(function (optionIndex, option) {
                    return $(option).data('tabby').split(':')[1] == data[1];
                }).length > 0;
            }
            return $tab.data('tabby').split(':')[1] == data[1];
        })];
    }
    function getPanels ($panels, data) {
        var $panels_filtered = $panels.filter(function (i, panel) {
            return $panels.eq(i).data('tabby') && $panels.eq(i).data('tabby').split(':')[0] == data[0];
        });
        return [$panels_filtered, $panels_filtered.filter(function (i, panel) {
            return $panels_filtered.eq(i).data('tabby').split(':')[1] == data[1];
        })];
    }


    $(function(){
        $HB = $('html, body');
    });
})(jQuery);

(function($){
    let $window = $(window);
    let $HB;
    let windowResizeTimer;
    let defaults = {
        scrollInView: 'close'
    };

    $window.on('resize', function (e) {
        clearTimeout(windowResizeTimer);
        windowResizeTimer = setTimeout(function () {
            $window.trigger('togglerThresholdResize');
        }, 300);
    });

    $.fn.toggler = function (options) {
        let $togglers = $();
        let $targets = $();

        let settings = $.extend({}, defaults, options);
        $targets = $targets.add($('[js-toggler-target]'));
        $togglers = $togglers.add($(this)).add($('[js-toggler-relative]'));

        return this.not('[js-toggler-relative]').each(function (i, toggler) {
            let $toggler = $(toggler).off('.toggler');
            let dataset = toggler.dataset || {};
            let $togglersOther = $togglers.filter('[data-toggler="'+ dataset.toggler +'"]').not($toggler);
            let single = dataset.togglerSingle || false;
            let close = dataset.togglerClose || false;
            let animate = dataset.togglerAnimate || true;
            let threshold = dataset.togglerThreshold || false;
            let $target = $targets.filter('[data-toggler="'+ dataset.toggler +'"]').addClass('toggler-target').off('.toggler');
            let maxHeight = 'none';
            let group = $toggler.data('toggler-group');

            if ( single ) {
                close = false;
            }
            if ( close ) {
                close = JSON.parse(close);
                close.$target = close.target ? $toggler.find(close.target) : $toggler;
                close.textOrigin = close.$target.text();
            }
            if ( animate ) {
                var heightFrom;
                var heightTo;
            }
            if ( threshold ) {
                threshold = JSON.parse(threshold) || {};
                var targetHeight = 0;
                var thresholdHeight = threshold.height;
                var thresholdFrom = threshold.from;

                $target.addClass('mod-threshold is-threshold');
                $toggler.addClass('mod-threshold');
                if ( !threshold.height ) {
                    thresholdHeight = parseInt($target.css('max-height'));
                }
                $target.removeClass('is-threshold');
                $window.on('togglerThresholdResize', function () {
                    togglerThresholdResize();
                });
                togglerThresholdResize();
                $toggler.on('updateToggler.toggler', function (e) {
                    e.stopPropagation();
                    togglerThresholdResize();
                });

                function togglerThresholdResize () {
                    thresholdHeight = parseInt($target.css('max-height'));
                    targetHeight = $target.removeClass('mod-threshold').outerHeight();
                    if ( !$target.hasClass('is-open') ) {
                        $target.addClass('mod-threshold');
                    }
                    if ( !$target.hasClass('is-threshold') && (!thresholdFrom || $window.width() <= thresholdFrom) && (!isNaN(thresholdHeight) && targetHeight > thresholdHeight) ) {
                        $target.addClass('is-threshold');
                        $toggler.addClass('is-threshold');
                    }
                    else if ( ($target.hasClass('is-threshold') && (isNaN(thresholdHeight) || targetHeight <= thresholdHeight)) && (!thresholdFrom || $window.width() <= thresholdFrom)) {
                        $target.removeClass('is-threshold');
                        $toggler.removeClass('is-threshold');
                        if ( $toggler.hasClass('is-open') ) {
                            $toggler.trigger('toggle', [true]);
                        }
                    }
                }
            }

            $toggler.on({
                'close.toggler': function (e, simple, scrollTo) {
                    e.preventDefault();
                    e.stopPropagation();
                    if ( $target.hasClass('is-animate') ) return;

                    if ( !single && $toggler.hasClass('is-open') ) {
                        $toggler.removeClass('is-open');
                        $togglersOther.removeClass('is-open');
                        if ( close ) {
                            close.$target.text(close.textOrigin);
                        }
                        if ( animate && !simple ) {
                            heightFrom = $target.removeClass('is-animate').outerHeight(true);
                            $target.removeClass('is-open');
                            if ( threshold ) {
                                $target.addClass('mod-threshold');
                            }
                            heightTo = $target.outerHeight(true);
                            $target.trigger('togglerOpen',{
                                heightFrom: heightFrom,
                                heightTo: heightTo,
                            });
                            $target.removeClass('mod-threshold').css('max-height', heightFrom).css('height', heightFrom).outerHeight(true);
                            $target.addClass('is-animate is-open is-closing').css('max-height', heightTo).off('.toggler-animate').on('transitionend.toggler-animate', function (e) {
                                if ( e.originalEvent.propertyName == 'max-height' ) {
                                    $target.removeClass('is-animate is-open is-closing').css('max-height', '').css('height', '').off('.toggler-animate').trigger('togglerClosed');
                                    if ( threshold ) {
                                        $target.addClass('mod-threshold');
                                    }
                                }
                            });

                            if ( !scrollTo && (settings.scrollInView || settings.scrollInView == 'close') ) {
                                var scrollTargetOffset = dataset.togglerScrollTarget && dataset.togglerScrollTarget == 'parent' ? $toggler.closest('[js-toggler-scroll-target]').offset() : dataset.togglerScrollTarget && dataset.togglerScrollTarget == 'target' ? $target.offset() : $toggler.offset();
                                var scrollTop = $window.scrollTop();
                                if ( scrollTargetOffset.top < scrollTop || scrollTargetOffset.top > scrollTop + $window.height() ) {
                                    $HB.not(':animated').stop().animate({
                                        scrollTop: scrollTargetOffset.top
                                    }, 500);
                                }
                            }

                            $target.trigger('close');
                        }
                        else {
                            $target.removeClass('is-open');
                        }
                    }
                },
                'open.toggler': function (e, simple) {
                    e.preventDefault();
                    e.stopPropagation();

                    $togglers.filter(`[data-toggler-group="${group}"]`).not($toggler).trigger('close', [null, true]);

                    if ( $target.hasClass('is-animate') ) return;

                    $toggler.addClass('is-open');
                    $togglersOther.addClass('is-open');
                    if ( close ) {
                        close.$target.text(close.text);
                    }
                    else if ( single == 'remove' ) {
                        $toggler.remove();
                        $togglersOther.remove();
                    }
                    if ( animate && !simple ) {
                        heightFrom = $target.removeClass('is-animate').outerHeight(true);
                        $target.addClass('is-open').removeClass('mod-threshold');
                        heightTo = $target.outerHeight(true);
                        $target.trigger('togglerOpen', {
                            heightFrom: heightFrom,
                            heightTo: heightTo,
                        });
                        $target.css('max-height', heightFrom).outerHeight(true);
                        $target.addClass('is-animate').css('max-height', heightTo).off('.toggler-animate').on('transitionend.toggler-animate', function (e) {
                            if ( e.originalEvent.propertyName == 'max-height' ) {
                                $target.removeClass('is-animate').css('max-height', '').off('.toggler-animate').trigger('togglerOpened');
                            }
                        });

                        $target.trigger('open');
                    }
                    else {
                        $target.addClass('is-open');
                    }

                },
                'click.toggler toggle.toggler': function (e, simple) {
                    !dataset.togglerPrevent && e.preventDefault();
                    if ( $target.hasClass('is-animate') ) return;

                    if ( $toggler.hasClass('is-open') && $toggler.context.href) {
                        document.location.href = $toggler.context.href;
                    }

                    if ( !single && $toggler.hasClass('is-open') ) {
                        $toggler.trigger('close');
                    }
                    else {
                        $toggler.trigger('open');
                    }
                },
                'destroy': () => {
                    $toggler.off('.toggler');
                    $togglers = $();
                    $targets = $();
                }
            });
        });
    };


    $(function(){
        $HB = $('html, body');
    });
})(jQuery);

$(function () {
    if ($('.accordion').length < 1) {
        return;
    }
    $('.accordion__item:first-child').find('.accordion__item-inner').slideDown();
    $(document).on('click', '.accordion__item-heading', function () {
        const $parentItem = $(this).closest('.accordion__item');
        const windowHeight = window.innerHeight;
        let parrentTop;
        let parentHeight;

        $parentItem.toggleClass('is-active');
        $parentItem.siblings().removeClass('is-active');
        $parentItem.children('.accordion__item-inner').slideToggle();
        $parentItem.siblings().children('.accordion__item-inner').slideUp();
        parrentTop = $parentItem.offset().top;
        parentHeight = $parentItem.height();

        function returnScrollToUser() {
            $([document.documentElement, document.body]).stop();
        }

        $([document.documentElement, document.body]).animate({
                // scrollTop: parentHeight > windowHeight ? parrentTop : parrentTop - ((windowHeight - parentHeight) / 2)
            },
            1000,
            function () {
                $([document.documentElement, document.body]).off("mousedown wheel DOMMouseScroll mousewheel keyup touchmove", returnScrollToUser);
            });
        $([document.documentElement, document.body]).one("mousedown wheel DOMMouseScroll mousewheel keyup touchmove", returnScrollToUser);
    });
});

AOS.init({
    disable: 'mobile'
});
app.bind('default article', function (context) {
    let $articleIcon = $('[js-article-icon]', context);

    $articleIcon.off('.articleIcon').on({
        'click.articleIcon': (event) => {
            $(event.currentTarget).toggleClass('is-active');
        }
    });
});

app.bind('default background-item', function(context) {
    const $window = $(window);
    const $backgroundWrapper = $('[js-background-wrapper]', context);
    $backgroundWrapper.each(function(index, el) {
        const backgroundOffset = Number($(this).context.dataset.backgroundOffset) || -75;
        const backgroundExtraWidth = Number($(this).context.dataset.backgroundExtraWidth) || 122;
        let $backgroundBlock = $(this).find('[js-background-block]');
        let $targetItems = $(el).find('[js-background-target]');
        let $activeTarget;
        $targetItems.each(function(index, el) {
            $(el).data('index', index + 1);
            $(el).off('.animateBackground').on({
                'mouseenter.animateBackground': function(e) {
                    $backgroundBlock.addClass('is-active');
                    $activeTarget = $(e.currentTarget);
                    $backgroundBlock.css({
                        'transform': `translateX(${$activeTarget.offset().left + backgroundOffset}px)`,
                         width: $activeTarget.width() + backgroundExtraWidth,
                    });
                }
            });
        });
        $window.off('.animateBackground').on({
            'resize.animateBackground': function() {
                if ($activeTarget) {
                    $backgroundBlock.css({
                        'transform': `translateX(${$activeTarget.offset().left + backgroundOffset}px)`,
                        width: $activeTarget.width() + backgroundExtraWidth,
                    });
                }
            }
        });
    });
});

app.bind('default billboard', (context) => {
    const $billboards = $('[js-billboard]', context);

    $billboards.each((billboardIndex, billboard) => {
        const $billboard = $billboards.eq(billboardIndex);
        const $dotsItems = $billboard.find('[js-billboard-dot]');
        const $backgroundPanels = $billboard.find('[js-billboard-background-panel]');
        const $dotsIcon = $billboard.find('[js-billboard-dots-icon]');
        const $dotsWrapper = $billboard.find('[js-billboard-dots]');
        let billboardTimer = null;
        let first = true;
        $billboard.off('.billboard').on({
            'pause.billboard': (e) => {
                clearTimeout(billboardTimer);
            },
            'playStart.billboard': (e, tabsData) => {
                let animationDuration = +tabsData.tab.context.dataset.animationDuration;
                clearTimeout(billboardTimer);
                billboardTimer = setTimeout(() => {
                    $dotsItems.eq((tabsData.tab.parent().index() + 1)%$dotsItems.length).trigger('changeTab');
                }, animationDuration);
            },
        });
        $dotsItems.on({
            'tabChanged.billboard': function (e) {
                if (first === true) {
                    const $tab = $(e.currentTarget);
                    moveArrow($tab);
                    $billboard.trigger('playStart', {tab: $tab});
                    first = false;
                }
            },
            'mouseenter.billboard changeTab.billboard': function (e) {
                const $tab = $(e.currentTarget).find('[js-tabby-tab]');
                if (!$(e.currentTarget).hasClass('is-open')) {
                    moveArrow($tab);
                    $dotsItems.removeClass('is-open');
                    $(e.currentTarget).addClass('is-open');
                    $billboard.trigger('playStart', {tab: $tab});
                    $tab.trigger('openTab');
                }
            },
        });
        $backgroundPanels.off('.billboard').on({
            'tabChanged.billboard': (e, payload) => {
                const currentVideos = e.currentTarget.querySelectorAll('video');
                const oldVideos = payload.otherPanels.find('video').get();

                $billboard.trigger('play.billboard', [Object.assign({panel: $(e.currentTarget)}, payload)]);
                oldVideos.forEach((video) => {
                    video.pause();
                });
                currentVideos.forEach((video) => {
                    video.currentTime = 0;
                    video.play();
                });
            },
        });
        $(window).on('resize', function() {
            setTimeout(() => {
                let $activatedDot =  $billboard.find('[js-billboard-dot].is-open');
                moveArrow($activatedDot);
            },200);
        });
        function moveArrow($activatedDot) {
            if (window.innerWidth <= 500) {
                $dotsIcon.css('transform', `translate(0, 0)`);
            } else {
                let offset = $activatedDot.offset().top - $dotsWrapper.offset().top - 13;
                $dotsIcon.css('transform', `translateY(${offset}px)`);
            }
        }
    });

}, -10);

/**
 * Инициализирует слайдеры
 * ToDO: додлелать универсальную ф-ию для инициализации всех каруселей
 *
 */

app.bind('default', function(context) {
    const GRID_GAP = 28; // отступы между блоками
    const GRID_GAP_SMALL = 16;
    /**
     *  @param carousel - карусель.
     */
    let initCarousel = (carousel) => {
        let $carousel = $(carousel),
            $carousel_parent = $carousel.closest('.carousel'),
            itemCount = 0;

        // дефолтные настройки
        let props = {
            slideBy: 1,
            items: 3,
            itemsS: 2,
            itemsXs: 2,
            itemsXxs: 1,
            showCount: false,
            margin: GRID_GAP,
            loop: false,
            navText: ['', ''],
            dots: false,
            dotsClass: 'carousel__dots',
            dotClass: 'carousel__dot',
            stageOuterClass: 'owl-stage-outer carousel__stage-outer',
            onInitialized: onInit,
        };

        $.each($carousel.data(), (key, value) => {
            props[key] = value;
        });
        if (props.showCount === true) props.loop = false;

        props.responsive = {
            0: {
                items: props.itemsXxs,
            },
            600: {
                items: props.itemsXs,
            },
            750: {
                items: props.itemsS,
            },
            1000: {
                items: props.itemsM,
            },
            1200: {
                items: props.items,
            }
        };

        $carousel.owlCarousel(props);
        let $arrowContainer = $(`[js-carousel-nav][data-slider="${props.slider}"]`);
        let $arrowPrev = $arrowContainer.find('[js-carousel-prev]');
        let $arrowNext = $arrowContainer.find('[js-carousel-next]');

        $arrowPrev.on('click', () => {
            $carousel.trigger('prev.owl.carousel');
        });

        $arrowNext.on('click', (e) => {
            $carousel.trigger('next.owl.carousel');
        });

        function getCurrentItems() {
            if (window.innerWidth >= 1200) {
                return props.items;
            } else if (window.innerWidth >= 1000) {
                if (props.itemsM) {
                    return props.itemsM;
                } else {
                    return props.items;
                }
            } else if (window.innerWidth >= 750) {
                if (props.itemsS) {
                    return props.itemsS;
                } else {
                    return props.items;
                }
            } else if (window.innerWidth >= 500) {
                if (props.itemsXs) {
                    return props.itemsXs;
                } else {
                    return props.items;
                }
            } else {
                if (props.itemsXxs) {
                    return props.itemsXxs;
                } else {
                    return props.items;
                }
            }
        }
        // callback функция при инициализации слайдера
        function onInit(e) {
            let $arrowContainer = $(`[js-carousel-nav][data-slider="${props.slider}"]`);
            let $arrowPrev = $arrowContainer.find('[js-carousel-prev]');
            let currentItems = getCurrentItems();
            const allSliderPack = e.item.count - currentItems + 1;
            itemCount = e.item.count;
            const hashNav = $carousel_parent.find('[js-carousel-hash-nav]');
            const templateName = $carousel_parent.attr('data-template');
            let defaultActiveSlide = hashNav.attr('data-active-default');

            if (props.loop === false) {
                $arrowPrev.addClass('is-disabled');
            }
            if (props.showCount === true && allSliderPack > 1) {
                $arrowContainer.find('[js-all-slides]').text(allSliderPack);
                $arrowContainer.find('[js-nav-count]').show();
            }
            if (allSliderPack < 2) {
                $arrowContainer.hide();
            }

            if (hashNav.length && defaultActiveSlide !== 'none') {
                hashNav.find(`.carousel-hash-nav__item[href="#${templateName}-${defaultActiveSlide || 1}"]`).addClass('is-active');
            }
        }
        $carousel.on('changed.owl.carousel', (e) => {
            const item = e.item.index;
            const $currentSlider = $(e.target);
            let currentItems = getCurrentItems();
            const allSliderPack = itemCount - currentItems + 1;
            $arrowContainer.find('[js-current-slider]').text(item + 1);
            const hashNav = $carousel_parent.find('[js-carousel-hash-nav]');
            const templateName = $carousel_parent.attr('data-template');

            if (props.loop === false) {
                if (item === 0) {
                    $arrowPrev.addClass('is-disabled');
                } else {
                    $arrowPrev.removeClass('is-disabled');
                }
                if (item === allSliderPack - 1) {
                    $arrowNext.addClass('is-disabled');
                } else {
                    $arrowNext.removeClass('is-disabled');
                }
            }

            if (hashNav.length) {
                const hashNavItems = hashNav.find('.carousel-hash-nav__item');
                hashNavItems.removeClass('is-active');
                hashNavItems.each(function(){
                    if($(this).attr('href') === `#${templateName}-${item + 1}`) {
                        $(this).addClass('is-active');
                    }
                });
            }

            if (props.background) {
                const $slideBackground = $(`${props.background}`, context);
                const $currentSlide = $currentSlider.find('.owl-item').eq(item);
                const $innerSlide = $currentSlide.find('[js-current-slide]');
                $slideBackground.css('backgroundImage',  `url(${$innerSlide.data('background')})`);
            }
        });
        $(window).resize(function() {
            let $arrowContainer = $(`[js-carousel-nav][data-slider="${props.slider}"]`);
            let currentItems = getCurrentItems();
            const allSliderPack = itemCount - currentItems + 1;
            if (allSliderPack < 2) {
                $arrowContainer.hide();
            } else {
                $arrowContainer.show();
            }
            if (props.showCount === true && allSliderPack > 1) {
                $arrowContainer.find('[js-all-slides]').text(allSliderPack);
            }
        });
    };
    $('[js-carousel]').each(function() {
        initCarousel(this);
    });
});

$(document).ready(function(){
    $(window).on('load resize', function(){
        if($(window).width() <= 767) {
            $('.carousel-hash-nav_seo .carousel-hash-nav__content').owlCarousel({
                items: 7
            });

            $('.mobile-carousel-init').owlCarousel({
                items: 1,
                loop: true
            });
        }
        else {
            $('.carousel-hash-nav_seo .carousel-hash-nav__content').trigger('destroy.owl.carousel');
            $('.mobile-carousel-init').trigger('destroy.owl.carousel');
        }
    }).trigger('resize');

});

$(document).ready(function () {

    var sync1 = $('.mousewheel-init .owl-carousel');
    var sync2 = $( ".years-nav-elements" );
    var slidesPerPage = 10; //globaly define number of elements per page
    var syncedSecondary = true;

    sync1.owlCarousel({
        items: 1,
        nav: false,
        autoplay: false,
        dots: false,
        loop: false,
        lazyLoad: true,
        slideSpeed: 250,
        onDragged: setActiveState,
        mouseDrag: true,
        touchDrag: true,
        responsive:{
            0:{
                items: 1,
                slideBy: 1,
                slideSpeed: 250
            },
            600:{
                items: 1,
                slideBy: 1,
                slideSpeed: 250
            },
            768:{
                items: 1,
                slideBy: 1,
                slideSpeed: 250
            },
            1000:{
                items: 1,
                slideBy: 1,
            },
            1200: {
                items: 1,
                slideBy: 1
            },
            1600: {
                items: 1,
                slideBy: 1
            }
        },
        onInitialized: carouselInitialized,
        navText: ['<svg width="100%" height="100%" viewBox="0 0 11 20"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M9.554,1.001l-8.607,8.607l8.607,8.606"/></svg>', '<svg width="100%" height="100%" viewBox="0 0 11 20" version="1.1"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M1.054,18.214l8.606,-8.606l-8.606,-8.607"/></svg>'],
    }).on('changed.owl.carousel', syncPosition);
    function carouselInitialized(event) {
        $('.years-progress-bg').removeClass('years-progress-hidden');
    }
    sync2
        .on('initialized.owl.carousel', function() {
            sync2.find(".owl-item").eq(0).addClass("active");
        })
        .owlCarousel({
            items: slidesPerPage,
            dots: false,
            nav: false,
            loop: false,
            lazyLoad: true,
            slideSpeed: 250,
            slideBy: slidesPerPage,
            responsive:{
                0:{
                    items: 3,
                    slideBy: 3,
                    slideSpeed: 250
                },
                600:{
                    items: 5,
                    slideBy: 5,
                    slideSpeed: 250
                },
                768:{
                    items: 7,
                    slideBy: 7,
                    slideSpeed: 250
                },
                1000:{
                    items: 9,
                    slideBy: 9
                },
                1200: {
                    items: slidesPerPage,
                    slideBy: slidesPerPage
                },
                1400: {
                    items: 20,
                    slideBy: 20,
                    margin: 24,
                    autoWidth: true
                }
            }
        });

    function syncPosition(el) {
        let count = el.item.count - 1;

        let current;
        if((el.relatedTarget._clones.length / 2) > (el.item.index + 1)){
            current = (el.item.index) + el.relatedTarget._clones.length / 2;
        }else{
            current = (el.item.index) - el.relatedTarget._clones.length / 2;
        }

        if (current < 0) {
            current = count;
        }
        if (current > count) {
            current = 0;
        }

        //end block

        sync2
            .find(".owl-item")
            .removeClass("active")
            .eq(current)
            .addClass("active");

        if (current == 0) {
            $('.mousewheel-years .nav-arrow_prev').addClass('is-disabled');
        } else {
            $('.mousewheel-years .nav-arrow_prev').removeClass('is-disabled');
        }

        if (current == count) {
            $('.mousewheel-years .nav-arrow_next').addClass('is-disabled');
        } else {
            $('.mousewheel-years .nav-arrow_next').removeClass('is-disabled');
        }

        if ($(window).width() < 1000) {
            sync2.data('owl.carousel').to(current, 250, true);
        } else {
            sync2.data('owl.carousel').to(current, 250, true);
        }
        $('.mousewheel-years .carousel-nav__current').text(current+1);

        let rounds = $('.year-item');
        rounds.removeClass('is-selected');
        for (let i = 0; i < rounds.length; i++) {
            if (i == current) {
                $(rounds[i]).addClass('is-selected');
            }
        }
    }

    sync2.on("click", ".owl-item", function(e) {
        e.preventDefault();
        var number = $(this).index();

        if ($(window).width() < 1000) {
            sync1.data('owl.carousel').to(number, 250, true);
        } else {
            sync1.data('owl.carousel').to(number, 250, true);
        }
        $(this).find('.year-item').addClass('is-selected');
        $(this).siblings().find('.year-item').removeClass('is-selected');

    });

    $(document).on('click', '.mousewheel-years .nav-arrow__arrow-next', function () {
        sync1.trigger('next.owl.carousel');
    });
    $(document).on('click', '.mousewheel-years .nav-arrow__arrow-prev', function () {
        sync1.trigger('prev.owl.carousel');
    });

});

function getSlideNumber() {
    let slidesList = $('.year-carousel .owl-item');
    let activeSlideAttr;
    slidesList.each(function () {
        if ($(this).hasClass('active') == true) {
            activeSlideAttr = $(this).index();
        }
    });
    return activeSlideAttr;
}
function setActiveState() {
    let activeSlide = getSlideNumber();
    let rounds = $('.year-item');
    rounds.removeClass('is-selected');
    for (let i = 0; i < rounds.length; i++) {
        if (i == activeSlide) {
            $(rounds[i]).addClass('is-selected');
        }
    }

}

    $('.person-card').closest('.grid-list').addClass('mobile-carousel-init');
    $('.accordion__item').find('.mobile-carousel-init').removeClass('mobile-carousel-init');


app.bind('default chart-bar', function (context) {
    let fontFamily;
    if (window.deviceType.browser.name.toLowerCase() !== 'ie') {
        fontFamily = '_museo';
    }
    let $chartListBar = $('[js-chart-bar]', context);
    const $window = $(window);
    $chartListBar.each(function(index, element) {
        const items = JSON.parse(element.dataset.items);
        new Chart(element, {
            type: 'bar',
            data: {
                labels: items.labels,
                datasets: [{
                    data: items.data,
                    date: items.date,
                    backgroundColor: items.backgroundColor,
                    borderWidth: 0,
                    hoverBackgroundColor: '#260100',
                    datalabels: {
                        display: false,
                    }
                }],
            },
            options: {
                layout: {
                    padding: {
                        top: 0,
                        bottom: 10,
                    }
                },
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            fontColor: '#9F9F9F',
                            fontFamily: fontFamily,
                            fontSize: 14,
                            fontStyle: 500,
                            labelOffset: ($window.width() < 750) ? -7 : -16,
                            padding: -40,
                            suggestedMin: 50,
                            suggestedMax: 100,
                            callback: function(value, index, values) {
                                if (index === 0) {
                                    return null
                                } else {
                                    return new Intl.NumberFormat('ru-RU').format(value)
                                }
                            }
                        },
                        gridLines: {
                            drawBorder: false,
                            zeroLineColor: 'transparent',
                            color: 'rgba(223,41,38, 0.16)',
                            tickMarkLength: ($window.width() < 750) ? 50 : 72,
                        },
                    }],
                    xAxes: [{
                        ticks: {
                            autoSkip: false,
                            maxRotation: 90,
                            minRotation: 90,
                            fontFamily: fontFamily,
                            fontColor: '#9F9F9F',
                            fontStyle: 500,
                            fontSize: 14,
                            padding: ($window.width() < 750) ? 5 : 14,
                        },
                        gridLines: {
                            display: false,
                        }
                    }]
                },
                hover: {
                    animationDuration: 0,
                },
                label: false,
                tooltips: {
                    yAlign: 'bottom',
                    xAlign: 'center',
                    enabled: false,
                    animationDuration: 0,
                    callbacks: {
                        beforeTitle: function(tooltipItem, data) {
                            if (data.datasets && data.datasets[0].date) {
                                return `<div class="chart-tooltip__date">${data.datasets[0].date[tooltipItem[0].index] || ''}</div>`;
                            }
                        },
                        title: function(tooltipItem) {
                            return `<div class="chart-tooltip__title">${new Intl.NumberFormat('ru-RU').format(tooltipItem[0].value) || ''}</div>`;
                        },
                        afterTitle: function() {
                            if (items.tooltipText) {
                                return `<div class="chart-tooltip__subtitle">${items.tooltipText || ''}</div>`;
                            }
                        },
                        label: function() {
                            return '';
                        }
                    },
                    custom: function(tooltip) {
                        // Tooltip Element
                        const canvas = this._chart.canvas;
                        const graphParent = this._chart.canvas.parentElement;
                        let tooltipEl = graphParent.querySelector("[js-chart-tooltip]");

                        if (!tooltipEl) {
                            tooltipEl = document.createElement("div");
                            tooltipEl.classList.add("chart-tooltip");
                            tooltipEl.classList.add("chart-tooltip_top");
                            tooltipEl.setAttribute('js-chart-tooltip', 'true');
                            tooltipEl.innerHTML = "<div class='chart-tooltip__inner' js-tooltip-inner></div>";
                            this._chart.canvas.parentNode.appendChild(tooltipEl);
                        }

                        // Hide if no tooltip
                        if (tooltip.opacity === 0) {
                            tooltipEl.style.opacity = 0;
                            return;
                        }

                        // Set caret Position
                        tooltipEl.classList.remove("above", "below", "no-transform");
                        if (tooltip.yAlign) {
                            tooltipEl.classList.add(tooltip.yAlign);
                        } else {
                            tooltipEl.classList.add("no-transform");
                        }

                        // Set Text
                        if (tooltip.body) {
                            let titleLines = tooltip.title || [];
                            let innerHtml = "";

                            titleLines.forEach(function(title) {
                                innerHtml +=  title;
                            });

                            let tableRoot = tooltipEl.querySelector("[js-tooltip-inner]");
                            tableRoot.innerHTML = innerHtml;
                        }

                        const positionY = this._chart.canvas.offsetTop;
                        const positionX = this._chart.canvas.offsetLeft;
                        const tickWidth = 72;
                        const $tooltipEl = $(tooltipEl);
                        let leftOffset = positionX + tooltip.caretX - tooltipEl.offsetWidth/2;

                        tooltipEl.classList.remove('chart-tooltip_arrow_right');
                        tooltipEl.classList.remove('chart-tooltip_arrow_left');

                        if (leftOffset - tickWidth < 0) {
                            leftOffset = positionX + tooltip.caretX;
                            tooltipEl.classList.add('chart-tooltip_arrow_left');
                        } else if (tooltip.caretX + tooltipEl.offsetWidth/2 > canvas.offsetWidth) {
                            leftOffset = positionX + tooltip.caretX - tooltipEl.clientWidth ;
                            tooltipEl.classList.add('chart-tooltip_arrow_right');
                        }
                        let topOffset = positionY + tooltip.caretY - $tooltipEl.height() + 22;
                        if (topOffset < 0) {
                            topOffset = 0;
                        } else if (positionY + tooltip.caretY + $tooltipEl.height() + 70 > canvas.offsetHeight) {
                            topOffset = positionY + tooltip.caretY - $tooltipEl.height() - 10;
                        }
                        tooltipEl.style.opacity = 1;
                        tooltipEl.style.left = leftOffset + "px";
                        tooltipEl.style.top = topOffset + "px";
                        tooltipEl.style.fontFamily = tooltip._bodyFontFamily;
                        tooltipEl.style.fontSize = tooltip.bodyFontSize + "px";
                        tooltipEl.style.fontStyle = tooltip._bodyFontStyle;
                        tooltipEl.style.padding = tooltip.yPadding + "px " + tooltip.xPadding + "px";
                    },
                }
            },
        });
        $window.off('.chartResize').on({
            'resize.chartResize': function() {
                $('[js-chart-tooltip]').each(function(index, element) {
                    $(element).css('opacity', '0');
                });
            }
        });
    });
});

app.bind('default chart-bar-stacked', function (context) {
    let fontFamily;
    if (window.deviceType.browser.name.toLowerCase() !== 'ie') {
        fontFamily = '_museo';
    }
    let $chartListStacked = $('[js-chart-bar-stacked]', context);
    const $window = $(window);
    $chartListStacked.each(function(index, element) {
        const items = JSON.parse(element.dataset.items);

        const generateDataset = (data) => {
            let result = [];

            data.forEach(function(element, index) {
                let backgroundList = [];
                for (let i = 0; i < element.data.length; i++) {
                    backgroundList.push(element.backgroundColor);
                }
                result.push({
                    data: element.data,
                    title: element.tooltipTitle,
                    backgroundColor: backgroundList,
                    hoverBackgroundColor: backgroundList,
                    borderColor: 'transparent',
                    hoverBorderColor: element.hoverBorderColor || '#260100',
                    borderSkipped: '',
                    borderWidth: {
                        top: (index === data.length - 1) ? 3 : 0,
                        left: 3,
                        right: 3,
                        bottom: (index === 0) ? 3 : 0,
                    },
                    hoverBorderWidth: {
                        top: (index === data.length - 1) ? 3 : 0,
                        left: 3,
                        right: 3,
                        bottom: (index === 0) ? 3 : 0,
                    },
                    datalabels: {
                       display: false,
                    },
                    stack: element.stack
                });
            });

            return result;
        };
        const datasets = generateDataset(items.datasets);
        const datasetsReverse =  datasets.slice().reverse();
        new Chart(element, {
            type: 'bar',
            data: {
                labels: items.labels,
                datasets: datasets,
                datasetsReverse: datasetsReverse,
                date: items.date,
            },
            options: {
                layout: {
                    padding: {
                        top: 35,
                        bottom: 10,
                    }
                },
                legend: {
                    display: false
                },
                hover: {
                    animationDuration: 40,
                },
                scales: {
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: items.beginAtZero || true,
                            fontFamily: fontFamily,
                            fontColor: '#9F9F9F',
                            fontSize: ($window.width() < 750) ? 12 : 14,
                            labelOffset: ($window.width() < 750) ? -7 : -16,
                            padding: -35,
                            callback: function(value, index, values) {
                                let symbol = '';
                                if (index === 0) {
                                    symbol = items.symbol || ' %';
                                } else {
                                    symbol = '      ';
                                }
                                return new Intl.NumberFormat('ru-RU').format(value) + symbol;
                            }
                        },
                        gridLines: {
                            drawBorder: false,
                            zeroLineColor: 'transparent',
                            color: 'rgba(223,41,38, 0.16)',
                            tickMarkLength: 35,
                        },
                    }],
                    xAxes: [{
                        stacked: true,
                        ticks: {
                            fontFamily: fontFamily,
                            fontColor: '#9F9F9F',
                            fontSize: ($window.width() < 750) ? 12 : 14,
                            padding: 13,
                            maxRotation: items.xLabelsRotation || 50,
                            minRotation: items.xLabelsRotation || 0,
                        },
                        gridLines: {
                            display: false,
                        },
                        barPercentage: items.noSpaceBetween ? 1.0 : 0.9,
                    }]
                },
                label: false,
                tooltips: {
                    enabled: false,
                    callbacks: {
                        title: function(tooltipItem, data) {
                            if (data.date) {
                                return `<div class="chart-tooltip__title">${data.date[tooltipItem[0].index] || ''}</div>`;
                            }
                        },
                        afterTitle: function(tooltipItem, data) {
                            if (data.datasetsReverse) {
                                let result = '<div class="chart-tooltip__rows">';
                                data.datasetsReverse.forEach(function(element, index) {
                                    result += `<div class="chart-tooltip__row">
                                    <div class="chart-tooltip__dots-item">
                                        <div class="dots-item">
                                            <div class="dots-item__background" style="background:${data.datasetsReverse[index].backgroundColor[0] || ''}"></div>
                                            <div class="dots-item__title">${data.datasetsReverse[index].title || ''}</div>
                                        </div>
                                    </div>
                                    <div class="chart-tooltip__value">${data.datasetsReverse[index].data[tooltipItem[0].index] || ''}${items.symbol || ' %'}</div>
                                </div>`;
                                });
                                result += '</div>';
                                return result;
                            }
                        },
                    },
                    custom: function (tooltip) {
                        const canvas = this._chart.canvas;
                        const graphParent = this._chart.canvas.parentElement;
                        let tooltipEl = graphParent.querySelector("[js-chart-tooltip]");
                        const $tooltipEl = $(tooltipEl);

                        if (!tooltipEl) {
                            tooltipEl = document.createElement("div");
                            tooltipEl.classList.add("chart-tooltip");
                            tooltipEl.classList.add("chart-tooltip_right");
                            tooltipEl.classList.add("chart-tooltip_title_small");
                            tooltipEl.setAttribute('js-chart-tooltip', 'true');
                            tooltipEl.innerHTML = `<div class='chart-tooltip__inner ${items.tooltipMods}' js-tooltip-inner></div>`;
                            this._chart.canvas.parentNode.appendChild(tooltipEl);
                        }

                        // Hide if no tooltip
                        if (tooltip.opacity === 0) {
                            tooltipEl.style.opacity = 0;
                            return;
                        }

                        // Set caret Position
                        tooltipEl.classList.remove("above", "below", "no-transform");
                        if (tooltip.yAlign) {
                            tooltipEl.classList.add(tooltip.yAlign);
                        } else {
                            tooltipEl.classList.add("no-transform");
                        }

                        // Set Text
                        if (tooltip.body) {
                            let titleLines = tooltip.title || [];
                            let innerHtml = "";

                            titleLines.forEach(function (title) {
                                innerHtml += title;
                            });

                            let tableRoot = tooltipEl.querySelector("[js-tooltip-inner]");
                            tableRoot.innerHTML = innerHtml;
                        }

                        const positionX = this._chart.canvas.offsetLeft;
                        const tickWidth = 50;
                        let leftOffset = positionX + tooltip.caretX;

                        tooltipEl.classList.remove('chart-tooltip_arrow_right');
                        tooltipEl.classList.remove('chart-tooltip_arrow_left');
                        tooltipEl.classList.remove('chart-tooltip_arrow_none');

                        if (leftOffset - tickWidth < 0) {
                            leftOffset = positionX + tooltip.caretX;
                            tooltipEl.classList.add('chart-tooltip_arrow_left');
                        } else if (tooltip.caretX + tooltipEl.offsetWidth > canvas.offsetWidth) {
                            leftOffset = positionX + tooltip.caretX - tooltipEl.clientWidth ;
                            tooltipEl.classList.add('chart-tooltip_arrow_right');
                        }
                        let topOffset = canvas.offsetHeight/2 - tooltipEl.offsetHeight/2 - 20;

                        tooltipEl.style.opacity = 1;
                        tooltipEl.style.left = leftOffset + "px";
                        tooltipEl.style.top = topOffset + "px";

                        tooltipEl.style.fontFamily = tooltip._bodyFontFamily;
                        tooltipEl.style.fontSize = tooltip.bodyFontSize + "px";
                        tooltipEl.style.fontStyle = tooltip._bodyFontStyle;
                        tooltipEl.style.padding =
                            tooltip.yPadding + "px " + tooltip.xPadding + "px";
                    },
                }
            }
        });

        $window.off('.chartResize').on({
            'resize.chartResize': function() {
                $('[js-chart-tooltip]').each(function(index, element) {
                    $(element).css('opacity', '0');
                });
            }
        });
    });
});

app.bind('default chart-line', function (context) {
    let fontFamily;
    if (window.deviceType.browser.name.toLowerCase() !== 'ie') {
        fontFamily = '_museo';
    }
    let $chartListLine = $('[js-chart-line]', context);
    const $window = $(window);
    $chartListLine.each(function(index, element) {
        const items = JSON.parse(element.dataset.items);
        const generateDataset = (data) => {
            let result = [];
            data.forEach(function(element) {
                result.push({
                    data: element.data,
                    tooltipData: element.tooltipData,
                    backgroundColor: 'transparent',
                    borderColor: element.backgroundColor,
                    borderWidth: 2,
                    lineTension: 0,
                    pointRadius: window.deviceType.mobile ? 0 : 4,
                    pointHitRadius: 30,
                    pointBorderColor: 'transparent',
                    pointBackgroundColor: 'transparent',
                    pointHoverBackgroundColor: window.deviceType.mobile ? 'transparent' : element.backgroundColor,
                    datalabels: {
                        display: false,
                    }
                });
            });

            return result;
        };
        const datasets = generateDataset(items.datasets);

        new Chart(element, {
            type: 'line',
            data: {
                labels: items.labels,
                datasets: datasets,
            },
            self: this,
            options: {
                layout: {
                    padding: {
                        top: 0,
                        bottom: 10,
                    }
                },
                legend: {
                    display: false
                },
                hover: {
                    animationDuration: 0,
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            fontColor: '#9F9F9F',
                            fontFamily: fontFamily,
                            fontSize: ($window.width() < 750) ? 12 : 14,
                            fontStyle: 500,
                            labelOffset: ($window.width() < 750) ? 0 : -2,
                            padding: ($window.width() < 750) ? 5 : 22,
                            suggestedMin: 50,
                            suggestedMax: 100,
                            callback: function(value, index, values) {
                                return new Intl.NumberFormat('ru-RU').format(value)
                            }
                        },
                        gridLines: {
                            color: 'rgba(159, 159, 159, 0.16)',
                            zeroLineColor: 'rgba(159, 159, 159, 0.16)',
                            tickMarkLength: 0,
                        },
                    }],
                    xAxes: [{
                        ticks: {
                            fontFamily: fontFamily,
                            fontColor: '#9F9F9F',
                            fontStyle: 500,
                            fontSize: ($window.width() < 750) ? 12 : 14,
                            padding: ($window.width() < 750) ? 10 : 20,
                        },
                        gridLines: {
                            color: 'rgba(159,159,159, 0.16)',
                            zeroLineColor: 'rgba(159, 159, 159, 0.16)',
                            tickMarkLength: 0,
                        }
                    }]
                },
                label: false,
                tooltips: {
                    enabled: false,
                    callbacks: {
                        title: function(tooltipItem, data) {
                            if (items.date) {
                                return `<div class="chart-tooltip__title">${items.date[tooltipItem[0].index] || ''}</div>`;
                            }
                        },
                        afterTitle: function(tooltipItem, data) {
                            if (data.datasets && data.datasets[tooltipItem[0].datasetIndex] && data.datasets[tooltipItem[0].datasetIndex].tooltipData) {
                                let result = '<div class="chart-tooltip__rows">';
                                const dataList = data.datasets[tooltipItem[0].datasetIndex].tooltipData[tooltipItem[0].index];

                                if (dataList) {
                                    dataList.forEach(function(element, index) {
                                        result += `<div class="chart-tooltip__row">
                                            <div class="chart-tooltip__dots-item">
                                                <div class="dots-item">
                                                    <div class="dots-item__background" style="background:${element.background || '' }"></div>
                                                    <div class="dots-item__title">${element.title || ''}</div>
                                                </div>
                                            </div> 
                                            <div class="chart-tooltip__value">${element.value || ''}</div>
                                        </div>`;
                                    });
                                }
                                result += '</div>';
                                return result;
                            }
                        },
                    },
                    custom:  window.deviceType.mobile ? '' : function (tooltip) {
                        if (tooltip.dataPoints && tooltip.dataPoints[0].xLabel !== '') {
                            // Tooltip Element
                            const canvas = this._chart.canvas;
                            const graphParent = canvas.parentElement;
                            let tooltipEl = graphParent.querySelector("[js-chart-tooltip]");

                            if (!tooltipEl) {
                                tooltipEl = document.createElement("div");
                                tooltipEl.classList.add("chart-tooltip");
                                tooltipEl.classList.add("chart-tooltip_arrow_right");
                                tooltipEl.classList.add("chart-tooltip_title_small");
                                tooltipEl.setAttribute('js-chart-tooltip', 'true');
                                tooltipEl.innerHTML = "<div class='chart-tooltip__inner' js-tooltip-inner></div>";
                                this._chart.canvas.parentNode.appendChild(tooltipEl);
                            }


                            // Hide if no tooltip
                            if (tooltip.opacity === 0) {
                                tooltipEl.style.opacity = 0;
                                return;
                            }

                            // Set caret Position
                            tooltipEl.classList.remove("above", "below", "no-transform");
                            if (tooltip.yAlign) {
                                tooltipEl.classList.add(tooltip.yAlign);
                            } else {
                                tooltipEl.classList.add("no-transform");
                            }

                            // Set Text
                            if (tooltip.body) {
                                let titleLines = tooltip.title || [];
                                let innerHtml = "";

                                titleLines.forEach(function (title) {
                                    innerHtml += title;
                                });

                                let tableRoot = tooltipEl.querySelector("[js-tooltip-inner]");
                                tableRoot.innerHTML = innerHtml;
                            }


                            let positionY = this._chart.canvas.offsetTop;
                            let positionX = this._chart.canvas.offsetLeft;

                            const tickWidth = 50;
                            const tooltipOffset = 20;
                            const $tooltipEl = $(tooltipEl);

                            tooltipEl.classList.add('chart-tooltip_arrow_right');
                            tooltipEl.classList.remove('chart-tooltip_arrow_left');

                            let leftOffset = positionX + tooltip.caretX - tooltipEl.offsetWidth - tooltipOffset;

                            if (leftOffset - tickWidth < 0) {
                                leftOffset = positionX + tooltip.caretX + tooltipOffset;
                                tooltipEl.classList.add('chart-tooltip_arrow_left');
                                tooltipEl.classList.remove('chart-tooltip_arrow_right');
                            }

                            let topOffset = positionY + tooltip.caretY - $tooltipEl.height()/2 - 6;

                            tooltipEl.style.opacity = 1;
                            tooltipEl.style.left = leftOffset + "px";
                            tooltipEl.style.top = topOffset + "px";
                            tooltipEl.style.fontFamily = tooltip._bodyFontFamily;
                            tooltipEl.style.fontSize = tooltip.bodyFontSize + "px";
                            tooltipEl.style.fontStyle = tooltip._bodyFontStyle;
                            tooltipEl.style.padding = tooltip.yPadding + "px " + tooltip.xPadding + "px";
                        }
                    },
                }
            }
        });

        let hideTooltip = () => {
            $(this).parent().find('[js-chart-tooltip]', context).css('opacity', 0);
        };

        $window.off('.chartResize').on({
            'resize.chartResize': function() {
                $('[js-chart-tooltip]').each(function(index, element) {
                    $(element).css('opacity', '0');
                });
            }
        });
        $(this).off('.chartMouse').on({
            'mouseout.chartMouse': () => {
               hideTooltip();
            }
        });
    });
});

app.bind('default chart-round', function (context) {
    let fontFamily;
    if (window.deviceType.browser.name.toLowerCase() !== 'ie') {
        fontFamily = '_museo';
    }
    let $chartListRound = $('[js-chart-round]', context);
    const $window = $(window);
    $chartListRound.each(function(index, element) {
        const items = JSON.parse(element.dataset.items);
        const type = element.dataset.type;
        const isMirror = element.dataset.mirror;
        new Chart(element, {
            type: 'doughnut',
            data: {
                labels: items.labels,
                datasets: [
                    {
                        data: items.dataset.data,
                        backgroundColor: items.dataset.backgroundColor,
                        hoverBackgroundColor: items.dataset.backgroundColor,
                        borderColor: "#fff",
                        hoverBorderColor: "#fff",
                        borderWidth: 1,
                        hoverBorderWidth: (type === 'half') ? 8 : 1,
                        datalabels: {
                            align: 'end',
                            anchor: 'end',
                            offset: 3,
                        }
                    }]
            },
            options: {
                rotation: (type === 'half') ? (isMirror === 'true') ? -(Math.PI / 2): Math.PI / 2 : -0.5 * Math.PI,
                circumference: (type === 'half') ? Math.PI : 2 * Math.PI,
                layout: {
                    padding: {
                        top: 30,
                        bottom: 10,
                    }
                },
                cutoutPercentage: 28,
                animation: {
                    animateRotate: false,
                    animateScale: true
                },
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            display: false,
                        },
                        gridLines: {
                            display: false,
                        },
                    }],
                    xAxes: [{
                        ticks: {
                            display: false,
                        },
                        gridLines: {
                            display: false,
                        }
                    }]
                },
                events: window.deviceType.mobile ? ["click"] : ["mousemove"],
                tooltips: {
                    yAlign: 'bottom',
                    xAlign: 'center',
                    caretSize: 4,
                    displayColors: false,
                    backgroundColor: '#fff',
                    bodyFontColor: '#101010',
                    bodyAlign: 'center',
                    bodyFontFamily: fontFamily,
                    bodyFontSize: 14,
                    xPadding: 14,
                    yPadding: 9,
                    cornerRadius: 0,
                    callbacks: {
                        label: function(tooltipItems, data) {

                            return `${data.labels[tooltipItems.index] || ''} ${Math.round((data.datasets[0].data[tooltipItems.index] * 100)/360)}%`;
                        },
                    }
                },
                onHover: function (evt, list) {
                    let labels = this.$datalabels._datasets[0];
                    for(let i in labels) {
                        if (labels[i].$context) {
                            labels[i].$context.hovered = false;
                        }
                    }
                    if (list.length !== 0 && list[0].$datalabels) {
                        list[0].$datalabels[0].$context.hovered = true;
                    }
                },
                plugins: {
                    datalabels: {
                        color: function(context) {
                            return context.hovered ? "#DF2926" : "#9f9f9f";
                        },
                        labels: {
                            title: {
                                font: {
                                    size: '14',
                                    family: fontFamily,
                                    weight: '500',
                                }
                            },

                        },
                        formatter: function(value, context) {
                            return Math.round((100 * value)/360) + '%';
                        }
                    }
                }
            },
        });
    });
});


if ( $.scrollTo ) {
    $.extend($.scrollTo.defaults, {
        axis: 'y',
        duration: 400,
        offset: -100,
    });
}

if ( $.fancybox ) {
    $.fancybox.defaults.loop = true;
    $.fancybox.defaults.buttons = [
        // "zoom",
        //"share",
        // "slideShow",
        //"fullScreen",
        //"download",
        // "thumbs",
        "close"
    ];
    $.fancybox.defaults.hash = false;
}

app.bind('fallbacks template-fallback', (context) => {
    if ( window.deviceType.browser.name == 'IE' ) {
        $('template[id]').each((templateIndex, template) => {
            $(template).replaceWith(`<script type="text/template" id="${template.id}">${template.innerHTML}</div>`);
        });
    }
}, -1000);

// app.bind('fallbacks svg-fallback', (context) => {
//     // Если понадобится, то надо переписать на этот скрипт!!
//     // https://github.com/Keyamoon/svgxuse
//     if ( window.deviceType.browser.name == 'IE' ) {
//         svg4everybody();
//     }
// }, -1000);


app.youTubeReady = new Promise((resolve, reject) => {
    window.onYouTubeIframeAPIReady = () => {
        resolve();
    }
});
app.bind('youtube-api', (context) => {
    const $scripts = $('script');

    // Не загружаем скрипт больше одного раза
    if ( !$scripts.toArray().some((script) => script.src.match('//www.youtube.com/iframe_api')) ) {
        $scripts.eq(0).before('<script src="//www.youtube.com/iframe_api">');
    }
}, -1000);


app.ymapsReady = new Promise((resolve, reject) => {
    window.onYmapsReady = () => {
        resolve();
    }
});
app.bind('ymaps-api', (context) => {
    const $scripts = $('script');

    // Не загружаем скрипт больше одного раза
    if ( !$scripts.toArray().some((script) => script.src.match('//api-maps.yandex.ru/2.1/')) ) {
        $scripts.eq(0).before('<script src="https://api-maps.yandex.ru/2.1/?lang=ru_RU&onload=onYmapsReady&apikey=a7c06c12-93c9-4d25-ab48-b373c359fcb2">');
    }
}, -1000);

app.bind('svg-fallback', (context) => {
    if ( window.deviceType.browser.name == 'IE' ) {
        $('script').eq(0).before('<script src="js/svgxuse.js" defer></script>');
    }
}, -1000);





app.bind('default cursor', function (context) {
    if ( window.deviceType.browser.name.toLowerCase() == 'ie' || window.deviceType.mobile) return;
    let $customCursor = $('[js-cursor-background]', context);
    const $window = $(window);
    let mouseX;
    let mouseY;

    $window.off('.customCursor').on({
        'mousemove.customCursor': (event) => {
            mouseX = event.clientX;
            mouseY = event.clientY;
        },
        'scroll.customCursor': () => {
            cancelAnimationFrame(requestAnimationFrame);
            cursorReposition();
        }
    });
    const cursorReposition = () => {
        $customCursor.css({
            'transform': `translate3d(${mouseX}px, ${window.pageYOffset + mouseY}px, 0)`,
        });
        requestAnimationFrame(cursorReposition);
    };
    requestAnimationFrame(cursorReposition);

    $('a, button, [js-cursor-target]').off('.customCursor').on({
        'mouseleave.customCursor': (e) => {
            $customCursor.removeClass('is-hover')
        },
        'mouseenter.customCursor': (e) => {
            $customCursor.addClass('is-hover')
        },
    });
    $('[js-cursor-off]').off('.customCursor').on({
        'mouseleave.customCursor': (e) => {
            $customCursor.removeClass('is-disabled')
        },
        'mouseenter.customCursor': (e) => {
            $customCursor.addClass('is-disabled')
        },
    });
    $(window).bind('tips.open on-show.selo', function () {
        $('a, button, [js-cursor-target]').off('.customCursor').on({
            'mouseleave.customCursor': (e) => {
                $customCursor.removeClass('is-hover')
            },
            'mouseenter.customCursor': (e) => {
                $customCursor.addClass('is-hover')
            },
        });
    });
});

app.bind('default form', function(context) {
    const $forms = $('.form', context);

    $forms.each((index, form) => {
        const $form = $(form);

        $form.form({
            success() {
                console.log('Success');
            },
        });
    });
});
app.bind('default widget-gallery', function(context){
    const $galleries = $('[js-gallery]', context);

    $galleries.each((galleryIndex, gallery) => {
        const $gallery = $(gallery);
        const galleryLinks = $gallery.find('a').filter((linkIndex, link) => link.href.split('?')[0].match(/\.(jpg|jpeg|png|gif)$/gi)).toArray();
        const galleryImages = galleryLinks.map((galleryLink) => {return {src: galleryLink.href} });

        let $fotoramaDiv = $gallery.fotorama({
            width: '100%',
            maxheight: 480,
            nav: 'thumbs',
            fit: 'scaledown',
            thumbwidth: 56,
            thumbheight: 56,
            thumbmargin: 16,
            arrows: false,
            swipe: true,
            allowfullscreen: 'native',
            click: false,
        });
        const $fotoramaWrapper = $fotoramaDiv.closest('[js-gallery-wrapper]');
        const fotorama = $fotoramaDiv.data('fotorama');
        let $arrowPrev = $fotoramaWrapper.find('[js-gallery-prev]');
        let $arrowNext = $fotoramaWrapper.find('[js-gallery-next]');
        changeDisabled();
        $('[js-gallery-next]', context).on('click', function() {
            fotorama.show('>');

        });
        $('[js-gallery-prev]', context).on('click', function() {
            fotorama.show('<');
        });
        $fotoramaWrapper.find('.fotorama__thumb').on('click', function() {
            changeDisabled();
        });
        $gallery.on('fotorama:load fotorama:show', (e, fotoramaApi, extra) => {
            const activeSlide = fotoramaApi.activeFrame.$stageFrame;
            changeDisabled();
            activeSlide.find('img').off('.fotorama').on({
                'click.fotorama': (e) => {
                    $.fancybox.open(galleryImages, {}, galleryLinks.findIndex((_link) => _link.href === e.currentTarget.src));
                },
            });
        });
        function changeDisabled() {
            if (fotorama.activeIndex === 0) {
                $arrowPrev.addClass('is-disabled');
            } else {
                $arrowPrev.removeClass('is-disabled');

                if (fotorama.activeIndex < fotorama.size) {
                    $arrowNext.removeClass('is-disabled');
                }

                if (fotorama.activeIndex === fotorama.size - 1) {
                    $arrowNext.addClass('is-disabled');
                }
            }
        }
    });
});
app.bind('default gradient', function(context) {
    const $gradientWrappers = $('[js-gradient-wrapper]', context);

    $gradientWrappers.each((index, el) => {
        const $wrapper = $(el);
        const $gradientItem = $wrapper.find('[js-gradient-item]');
        const wrapperOffsetTop = Math.floor($wrapper.offset().top);
        let timeout;
        let debounceTime = 16;

        /**
         * Устанавливает положение элемента.
         *
         * @param $el - Элемент которому необходимо указать положение.
         * @param {number|string} x - Позиция курсора по оси X.
         * @param {number|string} y - Позиция курсора по оси Y.
         */
        const setElementPosition = ($el, x, y) => {
            $el.css({
                'transform': `translate3d(${Math.floor(x)}px, ${Math.floor(y)}px, 0)`
            });
        };

        /**
         * Ограничивает частоту срабатывания функции.
         *
         * @param {Function} callback - Функция которую нужно вызвать.
         * @param {*} args - Аргументы функции которую нужно вызвать.
         * @param {number} time - Минимальный временной диапазон между вызовами функции (в миллисекундах).
         */
        const render = (callback, args, time) => {
            if ( !timeout ) {
                timeout = setTimeout(() => {
                    timeout = null;

                    requestAnimationFrame(() => callback(...args));
                }, time);
            }
        };


        $wrapper.on('mousemove', function(e) {
            const mouseX = e.pageX;
            const mouseY = e.pageY - wrapperOffsetTop;

            render(setElementPosition, [$gradientItem, mouseX, mouseY], debounceTime);
        });
        $wrapper.on('mouseenter', function(e) {
            $gradientItem.addClass('is-active');
        });
        $wrapper.on('mouseleave', function(e) {
            $gradientItem.removeClass('is-active');
        });
    });
});
!function() {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    app.bind('default grayscale', function (context) {
        // if ( window.deviceType.browser.name.toLowerCase() != 'ie' ) return;
        $('[js-grayscale]', context).each((blockIndex, block) => {
            const $block = $(block);
            const isImg = block.tagName === 'IMG';
            const type = $block.attr('js-grayscale') || 'replace';
            const imageUrl = isImg ? block.src : block.style.backgroundImage.replace(/^url\(['"]?|['"]?\)$/g, '');
            const color = $block.data('color');
            if ( !imageUrl ) return;
            grayscaleJS(imageUrl, color).then((payload = {}) => {
                if ( type == 'replace' ) {
                    if ( isImg ) {
                        block.src = payload.grayscale;
                    }
                    else {
                        block.style.backgroundImage = `url(${payload.grayscale})`;
                    }
                }
            });
        });
    });
    function grayscaleJS(src, color) {
        return new Promise((resolve, reject) => {
            const imgObj = new Image();
            imgObj.onload = () => {
                if (imgObj.width && canvas.height) {
                    canvas.width = imgObj.width;
                    canvas.height = imgObj.height;
                } else {
                    imgObj.style.position = 'absolute';
                    imgObj.style.pointerEvents = 'none';
                    imgObj.style.visibility = 'hidden';
                    imgObj.style.left = '-900px';
                    document.body.appendChild(imgObj);
                    canvas.width = imgObj.offsetWidth;
                    canvas.height = imgObj.offsetHeight;
                    document.body.removeChild(imgObj);
                }
                ctx.drawImage(imgObj, 0, 0);
                const imgPixels = ctx.getImageData(0, 0, canvas.width, canvas.height);
                for(let y = 0; y < imgPixels.height; y++){
                    for(let x = 0; x < imgPixels.width; x++){
                        const i = (y * 4) * imgPixels.width + x * 4;
                        let avg = (imgPixels.data[i] + imgPixels.data[i + 1] + imgPixels.data[i + 2]) / 3;
                        if (color === 'white') {
                            avg = 256;
                        }
                        imgPixels.data[i] = avg;
                        imgPixels.data[i + 1] = avg;
                        imgPixels.data[i + 2] = avg;
                    }
                }
                ctx.putImageData(imgPixels, 0, 0, 0, 0, imgPixels.width, imgPixels.height);
                resolve({grayscale: canvas.toDataURL()});
            };
            imgObj.src = src + '?123';
        });
    }
}();

app.bind('default', function(){
    $('.header').each(function() {
        const $context = $(this);
        const isLightTheme = $context.is('.header_theme_light');
        const $nav = $('.nav', $context);
        const $button = $('.button', $context);
        const $burgerButton = $('.burger-button', $context);
        let lastScrollTop = 100;

        $(document).on('scroll', function(e) {
            const currentScroll = $(document).scrollTop();

            if (currentScroll > lastScrollTop){
                $context.addClass('header_hidden');
            } else {
                $context.removeClass('header_hidden');
            }

            if (currentScroll > 100) {
                $context.addClass('header_bg');
                if (isLightTheme) {
                    $context.removeClass('header_theme_light');
                    $nav.removeClass('nav_theme_light');
                    $button.removeClass('button_gray');
                    $burgerButton.removeClass('burger-button_theme_light');
                }
            } else {
                $context.removeClass('header_bg');
                if (isLightTheme) {
                    $context.addClass('header_theme_light');
                    $nav.addClass('nav_theme_light');
                    $button.addClass('button_gray');
                    $burgerButton.addClass('burger-button_theme_light');
                }
            }

            lastScrollTop = currentScroll <= 100 ? 100 : currentScroll;
        });
    });
})

app.bind('default selo inputs basic', function(context){
    $('[js-selo]', context).selo({
        count: 2,
        itemTpl: (item, options) => {
            const itemData = item.dataset || {};
            itemData.title = itemData.title || item.innerHTML;
            itemData.value = item.value;

            return `
                <div js-selo-option class="field-options__item field-options-item ${item.value === options.defaultValue ? 'is-default' : ''}" ${ Object.keys(itemData).map((dataKey) => `data-${dataKey}=${JSON.stringify(itemData[dataKey])}`).join('') }>
                    ${options.isMultiple ? `
                        <div class="field-options-item__indicator">
                            <svg class="field-options-item__indicator-check svg-icon svg-icon_check" preserveAspectRatio="none"><use xlink:href="#sprite-icon-check"></use></svg>
                        </div>
                    ` : ''}
                    <div class="field-options-item__title" js-cursor-target>${ itemData.title }</div>
                </div>
            `
        },
    });

});

app.bind('default inputShadow inputs basic', function(context){
    $('[js-inputShadow]', context).inputShadow();
});

app.bind('default inputmask inputs basic', function(context){
    $('[js-input-phone]', context).attr('data-is-inputmask', true).inputmask({
        mask: '+7 (999) 999-99-99',
        placeholder: '+7 (___) ___-__-__',
        jitMasking: 0,
        clearMaskOnLostFocus: false,
        showMaskOnHover: false,
        showMaskOnFocus: true,
        isComplete: function (buffer, opts) {
            return Inputmask.isValid(buffer.join(''), {mask: opts.mask})
        },
        oncomplete: function () {
            $(this).trigger('maskComplete');
        },
        onincomplete: function () {
            $(this).trigger('maskIncomplete');
        }
    });

    $('[js-input-number]', context).attr('data-is-inputmask', true).each((inputIndex, input) => {
        const $input = $(input);
        let minValue = typeof $input.data('min') !== 'undefined' ? parseInt($input.data('min')) : $input.prop('min').length > 0 ? $input.prop('min') : 1;
        let maxValue = typeof $input.data('max') !== 'undefined' ? parseInt($input.data('max')) : $input.prop('max').length > 0 ? $input.prop('max') : 999999999;
        let value = parseInt($input.val().replace(/[^0-9.]/g, ''));

        $input.off('.input-number').on({
            'input.input-number': (e) => {
                setValue();
            },
        }).inputmask({
            mask: "9{*}",
            repeat: maxValue.length,
            greedy: true,
            regex: '[0-9]*',
            showMaskOnHover: false,
            showMaskOnFocus: false,
            isComplete: function (buffer, opts) {
                return Inputmask.isValid(buffer.join(''), {regex: opts.regex})
            }
        });

        function setValue (val = parseInt($input.val().replace(/[^0-9.]/g, ''))) {
            if ( val < minValue ) {
                value = minValue;
                $input.val(value).trigger('change');
            }
            else if ( val > maxValue ) {
                value = maxValue;
                $input.val(value).trigger('change');
            }
            else {
                value = val;
            }

            return value;
        }
    });

    $('[data-inputmask]', context).attr('data-is-inputmask', true).inputmask({
        oncomplete: function () {
            $(this).trigger('maskComplete');
        },
        onincomplete: function () {
            $(this).trigger('maskIncomplete');
        }
    });
});

app.bind('default layer', function(context){
    $('[js-overlayer]', context).layer({
        isOverlayer: true,
        beforeOpen: ($layer, layerData) => {
            app.use('basic', $layer);
        },
        afterOpen: ($layer, layerData) => {},
        afterClose: ($layer, layerData) => {}
    });

    $('[js-layer]', context).layer({
        beforeOpen: ($layer, layerData) => {
            app.use('basic', $layer);
        },
        afterOpen: ($layer, layerData) => {},
        afterClose: ($layer, layerData) => {}
    });
});

app.bind('default map', function (context) {
   const $maps = $('[js-map]', context);

    app.ymapsReady.then(() => {
        $maps.trigger('init.map');
    });

   $maps.each(function () {
      app.use('ymaps-api');
      const $map = $(this);
      const mapParams = $map.data('map-params') || {};
      // Настройки для карты по умолчанию
      const defaultMapSettings = {
         center: [55.76, 37.64],
         zoom: 16,
         maxZoom: 17,
         controls: [],
         margin: [30, 50, 50, 30],
      };
      // Объект с маркерами, кластерами и их настройками
      const mapState = {
         controller: null,
         placemarks: [],
         settings: $.extend({}, defaultMapSettings, mapParamsNormalizer(mapParams)),
      };
      const isSimple = $map.data('is-simple') === true;
      let mapController = null;

      $map.on({
         'init.map'(e) {
            if ( $map.data('map-inited') ) return;
            $map.trigger('unbind-events.map');

            // Добавим карту
            mapController = mapState.controller = new ymaps.Map($map[0], mapState.settings, {
               suppressMapOpenBlock: true,
               maxZoom: mapState.settings.maxZoom,
            });

            // Добавим маркеры и привяжем события
            $map.data('map-inited', true).trigger('create-marks.map').trigger('bind-events.map');

            // Добавим кнопки для навигации
            mapController.controls.add('zoomControl', {
               size: 'small',
               position: {top: 200, right: 30, bottom: 'auto', left: 'auto'},
            });
            mapController.behaviors.disable('scrollZoom');
         },
         'create-marks.map'(e) {
            mapState.placemarks = mapPlacemarksNormalizer(mapParams.items);

            if ( mapState.placemarks.length ) {
               $map.trigger('fit.map');
            }
            $map.trigger('fit.map');
         },
         'fit.map': (e) => {
            mapController.geoObjects.add(mapState.placemarks[0]);
            mapController.container.fitToViewport();
         },
      });
   });

   function coordinatesNormalizer (coordinates) {
      if ( typeof coordinates === 'string' ) {
         return coordinates.split(',').map((item) => item.replace(/[^.\d]/g, ''));
      }
      else if ( typeof coordinates === 'object' && coordinates.lat.toString().replace(/[^.\d]/g, '').length && coordinates.lon.toString().replace(/[^.\d]/g, '').length ) {
         return [coordinates.lat, coordinates.lon].map((item) => item.toString().replace(/[^.\d]/g, ''));
      }
      else if ( Array.isArray(coordinates) ) {
         return coordinates;
      }
      return null;
   }

   function mapPlacemarksNormalizer (items = [], params = {}) {
      if ( !items || !items.length ) return;

      $.extend(params, {
         iconLayout: 'default#image',
         iconImageHref: '/images/map/placemark.svg',
         iconImageSize: [60, 84],
         iconImageOffset: [0, -84],
      });

      return items.map((item) => {
         const itemCoords = coordinatesNormalizer(item.coords);
         if ( !itemCoords ) return null;

         return new ymaps.Placemark(itemCoords, {}, params);
      }).filter((item) => item != null);
   }

   function mapParamsNormalizer(params = {}) {
      const stripParams = ['items', 'type'];
      const params_normalized = {...params};

      if ( typeof params_normalized.center === 'string' ) {
         params_normalized.center = coordinatesNormalizer(params_normalized.center);
      }

      return Object.keys(params_normalized).reduce((obj, current, currentIndex, source) => {
         if ( !stripParams.includes(current) ) {
            obj[current] = params_normalized[current];
         }
         return obj;
      }, {});
   }
});
'use strict';
jQuery.extend(jQuery.easing,
    {
        def: 'easeOutQuad',
        easeInOutCubic: function (x, t, b, c, d) {
            if ((t/=d/2) < 1) return c/2*t*t*t + b;
            return c/2*((t-=2)*t*t + 2) + b;
        },
    });
jQuery(document).ready(function ($) {
    var barCompletePX,
        barInProgressPX,
        bodyMarginTop,
        calcBodyMarginTop,
        offsetTop,
        windowHeight,
        windowWidth,
        documentOffsetTop,
        widgetOffsetTop,
        widgetBottom,
        postHeight,
        $postEnding = $('.pn-post-ending'),
        sectionOffsetTopWindow,
        errorMargin,
        postTitle = $('h1').text(),
        pn_config = {"sections":[{"class":"pn-section-0"},{"class":"pn-section-1"},{"class":"pn-section-2"},{"class":"pn-section-3"},{"class":"pn-section-4"},{"class":"pn-section-5"},{"class":"pn-section-6"},{"class":"pn-section-7"},{"class":"pn-section-8"},{"class":"pn-section-9"},{"class":"pn-section-10"},{"class":"pn-section-11"},{"class":"pn-section-12"},{"class":"pn-section-13"},{"class":"pn-section-14"},{"class":"pn-section-15"},{"class":"pn-section-16"},{"class":"pn-section-17"},{"class":"pn-section-18"},{"class":"pn-section-19"},{"class":"pn-section-20"},{"class":"pn-section-21"},{"class":"pn-section-22"},{"class":"pn-section-23"},{"class":"pn-section-24"},{"class":"pn-section-25"},{"class":"pn-section-26"},{"class":"pn-section-27"},{"class":"pn-section-28"},{"class":"pn-section-29"},{"class":"pn-section-30"},{"class":"pn-section-31"},{"class":"pn-section-32"}],"post_title":postTitle,"overlap_site_content":"0","section_offset":"50","progress_bar_algorithm":"algorithm_1","bar_ending":"end_of_content","sections_container_selectors":""};


    initPlugin();
    function initPlugin()
    {

        offsetTop = 0;
        windowWidth = $(window).width();
        windowHeight = $(window).height();
        postHeight = getPostHeight();
        documentOffsetTop = $(document).scrollTop();
        errorMargin = 3;
        sectionOffsetTopWindow = parseInt(pn_config.section_offset);
        widgetBottom = ($postEnding.length ? $postEnding.offset().top : 0);

        initBodyMarginTop();
        bodyMarginTop = calcBodyMarginTop();

        postHeight = getPostHeight();
        if(typeof(pn_config.sections)=='undefined')
            return;

        initSections();
        initNavSectionsList();
        initSectionMarks();
        initNavigationWidget();

        //assign event handlers
        $('#pn-navigation-bar, .pn-section-mark, .pn-nav-switch, .pn-navigation-info .pn-sections-list li, ul.navigation_widget_list li').on({
            mouseenter: handleDesktopHoverIn,
            mouseleave: handleDesktopHoverOut,
        });
        $(document).on('click touchstart', handleDocumentClickTouch);
        $('#pn-navigation-bar').on('touchstart', handleNavBarTouch);
        $('.pn-section-mark').on('click touchstart', handleSectionMarkClickTouch);
        $('.pn-progress-bar-wrapper,.pn-clickable-area').on('click touchstart', handleProgressBarClickTouch);
        $('.pn-next,.pn-prev').on('click touchstart', handlePaginationClickTouch);
        $('.pn-nav-switch').on('click touchstart', handleNavSwitchClickTouch);
        $('ul.pn-sections-list li').on('click touchstart', handleNavSectionsClickTouch);
        $('ul.navigation_widget_list li').on('click touchstart', handleNavigationWidgetClickTouch);
        $(window).on('resize scroll orientationchange', handleScreenChange);
        $(window).on('orientationchange', setSectionsMenuHeight);

        setInterval(documentHeightChange, 200);

        calcProgress(true);
    }

    function calcProgress(force)
    {
        force = (typeof force !== 'undefined' ? force : false);

        if(!force)
        {
            //check if we need to re-calculate the progress bar or NavigationWidget
            if(windowWidth==$(window).width() &&
                windowHeight==$(window).height() &&
                postHeight==getPostHeight() &&
                documentOffsetTop==$(document).scrollTop())
                return;
        }

        windowWidth = $(window).width();
        windowHeight = $(window).height();
        postHeight = getPostHeight();
        documentOffsetTop = $(document).scrollTop();
        widgetBottom = ($postEnding.length ? $postEnding.offset().top : 0);
        bodyMarginTop = calcBodyMarginTop();

        if(pn_config.progress_bar_algorithm=='algorithm_1')
        {
            barInProgressPX = 0;
            barCompletePX = calcPosXAlg1(documentOffsetTop);
        }

        if(pn_config.progress_bar_algorithm=='algorithm_2')
        {
            barInProgressPX = calcPosXAlg2(windowHeight-sectionOffsetTopWindow-offsetTop);
            barCompletePX = calcPosXAlg2(documentOffsetTop);
        }

        setBodyMarginTop();

        //adjust position of widget and progress bar
        adjustOffsetTop();

        //handle sticky option
        navigationWidgetSticky();

        setProgressBar();

        if(typeof(pn_config.sections)=='undefined')
            return;

        calcSections();
        setNavSectionsList();
        setSectionsMarks();
        setNavigationWidget();
        setCurrentSection();
    }

    function calcSections()
    {
        var removeSections = [];
        pn_config.sections.forEach(function (el, index, array) {
            var $section = $('.' + el.class);
            var countRemaining = array.length-index-1;

            if($section.length)
            {
                el.visible = ($section.is(':visible') ? 1 : 0);

                if(pn_config.progress_bar_algorithm=='algorithm_1')
                {
                    el.positionPX = calcPosXAlg1($section.offset().top-sectionOffsetTopWindow-offsetTop);
                    if(el.positionPX>(windowWidth-8-(countRemaining*15)))
                        el.positionPX = windowWidth-8-(countRemaining*15);
                }

                if(pn_config.progress_bar_algorithm=='algorithm_2')
                {
                    el.positionPX = calcPosXAlg2($section.offset().top-sectionOffsetTopWindow-offsetTop);
                }
            }
            else
                removeSections.push(index);
        });
        removeDeadSections(removeSections);
    }

    function setProgressBar()
    {
        if(!$('#pn-navigation-bar').length)
            return;
        $('.pn-complete').css('width', barCompletePX + 'px');
        $('.pn-in-progress').css({
            'width' : barInProgressPX + 'px',
            'left' : barCompletePX + 'px'
        });
    }

    function setSectionsMarks()
    {
        if(!$('.pn-section-mark').length)
            return;
        pn_config.sections.forEach(function (el, index, array) {
            var $sectionMark = $('.' + el.class + '-mark');
            $sectionMark.css('left', el.positionPX + 'px');
            if(!el.visible)
            {
                $sectionMark.hide();
                return;
            }
            else
                $sectionMark.show();

            //determine section status: completed, in-progress, unseen
            if((el.positionPX-errorMargin)>(barInProgressPX+barCompletePX))
            {
                $sectionMark.removeClass('pn-section-in-progress pn-section-complete');
            }
            else if((el.positionPX-errorMargin)>barCompletePX)
            {
                $sectionMark.removeClass('pn-section-complete');
                $sectionMark.addClass('pn-section-in-progress');
            }
            else
            {
                $sectionMark.removeClass('pn-section-in-progress');
                $sectionMark.addClass('pn-section-complete');
            }

            //make sure that section tooltip doesn't go beyond the visible screen
            var $sectionInfo = $sectionMark.find('.pn-section-tooltip-wrapper');
            if($sectionMark.offset().left+parseInt($sectionInfo.css('width'))>windowWidth)
                $sectionInfo.addClass('pn-display-left');
            else
                $sectionInfo.removeClass('pn-display-left');
        });
    }

    function setNavSectionsList()
    {
        pn_config.sections.forEach(function (el, index, array) {
            var $sectionsListItem = $('.' + el.class + '-list');
            if(!el.visible)
            {
                $sectionsListItem.hide();
                return;
            }
            else
                $sectionsListItem.show();
        });
    }

    function setNavigationWidget()
    {
        var $sectionsWidget = $('ul.navigation_widget_list');
        if(!$sectionsWidget.length)
            return;

        pn_config.sections.forEach(function (el, index, array) {
            var $sectionsWidget = $('.' + el.class + '-widget'),
                nextSection = array[index+1],
                nextSectionPosPX,
                progress;

            if(!el.visible)
            {
                $sectionsWidget.hide();
                return;
            }
            else
                $sectionsWidget.show();

//			nextSectionPosPX = (typeof(nextSection)!='undefined' ? Math.round(nextSection.positionPX) : windowWidth);
            if(typeof(nextSection)!='undefined')
            {
                nextSectionPosPX = Math.round(nextSection.positionPX);
            }
            else
            {
                var temp;
                if(pn_config.progress_bar_algorithm=='algorithm_1')
                    temp = ($postEnding.length ? $postEnding.offset().top : $(document).height());
                if(pn_config.progress_bar_algorithm=='algorithm_2')
                    temp = ($postEnding.length ? $postEnding.offset().top : $(document).height())-sectionOffsetTopWindow-offsetTop;
                nextSectionPosPX = Math.round(windowWidth*temp/postHeight);
            }

            if((el.positionPX-errorMargin)>barCompletePX)
            {
                $sectionsWidget.removeClass('pn-active');
                $sectionsWidget.find('.section_progress').css('width', '0');
            }
            else if((el.positionPX-errorMargin)<=barCompletePX && barCompletePX<nextSectionPosPX)
            {
                progress = ((barCompletePX-el.positionPX)/(nextSectionPosPX-el.positionPX))*100;
                $sectionsWidget.addClass('pn-active');
                $sectionsWidget.find('.section_progress').css('width', progress + '%');
            }
            else
            {
                $sectionsWidget.addClass('pn-active');
                $sectionsWidget.find('.section_progress').css('width', '100%');
            }
        });
    }

    function navigationWidgetSticky()
    {
        var $sectionsWidget = $('ul.navigation_widget_list');
        if(!$sectionsWidget.length || $sectionsWidget.hasClass('pn-no-sticky'))
            return;

        if($sectionsWidget.css('position')!='fixed')
            widgetOffsetTop = $sectionsWidget.offset().top;
        var sectionsWidgetHeight = $sectionsWidget.height();
        var rowHeight = widgetBottom-widgetOffsetTop;

        if(window.innerwidth<=767)
        {
            //widget default position
            $sectionsWidget.css({
                'position': '',
                'top': '',
                'bottom': '',
                'width': '',
                'margin-top': '',
                'margin-bottom': '',
            });
            return;
        }

        if(sectionsWidgetHeight<windowHeight &&
            widgetOffsetTop-offsetTop-30<documentOffsetTop &&
            widgetOffsetTop-offsetTop-30+rowHeight-sectionsWidgetHeight>documentOffsetTop)
        {
            $sectionsWidget.css({
                'position': 'fixed',
                'top': (offsetTop+30)+'px',
                'bottom': 'auto',
                'width': $sectionsWidget.parent().css('width'),
                'margin-top': '0',
                'margin-bottom': '0',
            });
        }
        else if(sectionsWidgetHeight<windowHeight &&
            widgetOffsetTop-offsetTop-30+rowHeight-sectionsWidgetHeight<=documentOffsetTop &&
            (rowHeight-sectionsWidgetHeight>0))
        {
            $sectionsWidget.css({
                'position': 'fixed',
                'top': '',
                'bottom': (windowHeight-widgetBottom+documentOffsetTop)+'px',
                'width': $sectionsWidget.parent().css('width'),
                'margin-top': '0',
                'margin-bottom': '0',
            });
        }
        else if(sectionsWidgetHeight>=windowHeight &&
            widgetOffsetTop+30+sectionsWidgetHeight<documentOffsetTop+windowHeight &&
            widgetOffsetTop+30+rowHeight>documentOffsetTop+windowHeight)
        {
            $sectionsWidget.css({
                'position': 'fixed',
                'top': '',
                'bottom': '30px',
                'width': $sectionsWidget.parent().css('width'),
                'margin-top': '0',
                'margin-bottom': '0',
            });
        }
        else if(sectionsWidgetHeight>=windowHeight &&
            widgetOffsetTop+30+rowHeight<=documentOffsetTop+windowHeight &&
            (rowHeight-sectionsWidgetHeight>0))
        {
            $sectionsWidget.css({
                'position': 'fixed',
                'top': '',
                'bottom': (windowHeight-widgetBottom+documentOffsetTop)+'px',
                'width': $sectionsWidget.parent().css('width'),
                'margin-top': '0',
                'margin-bottom': '0',
            });
        }
        else
        {
            $sectionsWidget.css({
                'position': '',
                'top': '',
                'bottom': '',
                'width': '',
                'margin-top': '',
                'margin-bottom': '',
            });
        }
    }

    function adjustOffsetTop()
    {
        var $navigationBar = $('#pn-navigation-bar');
        var $sectionsWidget = $('ul.navigation_widget_list');

        var adminBarOffset = 0;

        if($('#wpadminbar').length)
        {
            if($('#wpadminbar').css('position')=='fixed')
                adminBarOffset = $('#wpadminbar').height();
            else if($('#wpadminbar').css('position')=='absolute')
            {
                adminBarOffset = ($('#wpadminbar').height()>documentOffsetTop ? $('#wpadminbar').height()-documentOffsetTop : 0);
            }
        }
        adminBarOffset = Math.round(adminBarOffset);

        if($navigationBar.length && $navigationBar.css('position')=='fixed')
        {
            $navigationBar.css('top', adminBarOffset + 'px');
            offsetTop = adminBarOffset + bodyMarginTop;
        }
        else
            offsetTop = adminBarOffset;
        offsetTop = Math.round(offsetTop);

        if($sectionsWidget.length && $sectionsWidget.css('position')=='fixed' && false)
        {
            if(typeof($sectionsWidget.attr('data-top'))=='undefined')
                $sectionsWidget.attr('data-top', parseInt($sectionsWidget.css('top')));
            $sectionsWidget.css('top', parseInt($sectionsWidget.attr('data-top')) + offsetTop + 'px');
        }
    }

    function setCurrentSection()
    {
        var $lastSection = $('.pn-section-mark.pn-section-complete:last');
        $('.pn-section-current').html($lastSection.length ? $lastSection.attr('data-title') : pn_config.post_title);
        if($lastSection.length)
        {
            $('.pn-navigation-info .pn-sections-list li').removeClass('pn-active');
            $('.' + $('.pn-section-mark.pn-section-complete:last').attr('data-section-class') + '-list').addClass('pn-active');
        }
        else
            $('.pn-navigation-info .pn-sections-list li').removeClass('pn-active');
    }

    function getPostHeight()
    {
        var postHeight;
        if(pn_config.bar_ending=='end_of_content')
        {
            if(pn_config.progress_bar_algorithm=='algorithm_1')
                postHeight = ($postEnding.length ? $postEnding.offset().top : $(document).height());
            if(pn_config.progress_bar_algorithm=='algorithm_2')
                postHeight = ($postEnding.length ? $postEnding.offset().top : $(document).height())-sectionOffsetTopWindow-offsetTop;
        }
        if(pn_config.bar_ending=='end_of_page')
        {
            postHeight = $(document).height()-sectionOffsetTopWindow-offsetTop;
            if(pn_config.progress_bar_algorithm=='algorithm_1')
                postHeight = $(document).height();
            if(pn_config.progress_bar_algorithm=='algorithm_2')
                postHeight = $(document).height()-sectionOffsetTopWindow-offsetTop;
        }
        return postHeight;
    }

    //accordions/tabs/other may change document height
    //then we need to update the progress bar
    function documentHeightChange()
    {
        if(postHeight!=getPostHeight())
            $(window).trigger('resize');
    }

    function removeDeadSections(removeSections)
    {
        removeSections.sort(function(a,b){return b-a});
        removeSections.forEach(function (el, index, array) {
            $('.' + pn_config.sections[el].class + '-mark, .' + pn_config.sections[el].class + '-widget, .' + pn_config.sections[el].class + '-list').remove();
            pn_config.sections.splice(el,1);
        })
    }

    function initSections()
    {
        //remove sections that doesn't exist in the document
        var removeSections = [];
        pn_config.sections.forEach(function (el, index, array) {
            if(!$('.' + el.class).length)
                removeSections.push(index);
        });
        removeDeadSections(removeSections);

        //calculate sections position and sort by value
        pn_config.sections.forEach(function (el, index, array) {
            var $section = $('.' + el.class);
            var countRemaining = array.length-index-1;

            el.visible = ($section.is(':visible') ? 1 : 0);

            if(pn_config.progress_bar_algorithm=='algorithm_1')
            {
                el.positionPX = calcPosXAlg1($section.offset().top-sectionOffsetTopWindow-offsetTop);
                if(el.positionPX>(windowWidth-8-(countRemaining*15)))
                    el.positionPX = windowWidth-8-(countRemaining*15);
            }

            if(pn_config.progress_bar_algorithm=='algorithm_2')
            {
                el.positionPX = calcPosXAlg2($section.offset().top-sectionOffsetTopWindow-offsetTop);
            }
        });
        pn_config.sections.sort(function(a, b) {
            return (a.positionPX>b.positionPX ? 1 : (a.positionPX<b.positionPX ? -1 : 0));
        });
    }

    function initNavSectionsList()
    {
        if($('ul.pn-sections-list li').length)
        {
            var sectionsList = [];
            pn_config.sections.forEach(function (el, index, array) {
                var $sectionList = $('.' + el.class + '-list');
                sectionsList.push($sectionList);
            });
            $('ul.pn-sections-list li').detach();
            $('ul.pn-sections-list').append(sectionsList);
        }
    }

    function initSectionMarks()
    {
        if($('.pn-section-mark').length)
        {
            var sectionsMarksArr = [];
            var max = pn_config.sections.length;
            pn_config.sections.forEach(function (el, index, array) {
                var $sectionMark = $('.' + el.class + '-mark');
                $sectionMark.find('.pn-pagination-index').html(index+1);
                $sectionMark.find('.pn-pagination-max').html(max);
                if(index==0)
                {
                    $sectionMark.find('.pn-prev.pn-button').addClass('pn-inactive');
//					$sectionMark.find('.pn-prev.pn-button').remove();
                }
                else
                {
                    var $sectionNext = $('.' + array[index-1].class + '-mark');
                    $sectionMark.find('.pn-prev.pn-button').attr('data-section-class',$sectionNext.attr('data-section-class'));
                }

                if(index==(max-1))
                {
                    $sectionMark.find('.pn-next.pn-button').addClass('pn-inactive');
//					$sectionMark.find('.pn-next.pn-button').remove();
                }
                else
                {
                    var $sectionPrev = $('.' + array[index+1].class + '-mark');
                    $sectionMark.find('.pn-next.pn-button').attr('data-section-class', $sectionPrev.attr('data-section-class'));
                }
                sectionsMarksArr.push($sectionMark);
            });
            $('.pn-section-mark').detach();
            $('#pn-navigation-bar .pn-progress-bar').append(sectionsMarksArr);
        }
    }

    function initNavigationWidget()
    {
        if($('#navigation_widget_wrapper').length && $('#navigation_widget_wrapper_source').length)
        {
            $('#navigation_widget_wrapper').html($('#navigation_widget_wrapper_source').html());
            $('#navigation_widget_wrapper_source').remove();
        }

        if($('ul.navigation_widget_list li').length)
        {
            var sectionsWidgetArr = [];
            pn_config.sections.forEach(function (el, index, array) {
                var $sectionsWidget = $('.' + el.class + '-widget');
                sectionsWidgetArr.push($sectionsWidget);
            });
            $('ul.navigation_widget_list li').detach();
            $('ul.navigation_widget_list').append(sectionsWidgetArr);
        }
    }

    function initBodyMarginTop()
    {
        calcBodyMarginTop = bodyMarginTopAlg0;
        if($('#pn-navigation-bar').length)
        {
            //case-1;case-4
            if(!$('#pn-navigation-bar').hasClass('pn-no-sections') &&
                $('#pn-navigation-bar').hasClass('pn-navigation-menu-always'))
                calcBodyMarginTop = bodyMarginTopAlg1;

            //case-2;case-3
            if(!$('#pn-navigation-bar').hasClass('pn-no-sections') &&
                !$('#pn-navigation-bar').hasClass('pn-sections-marks-on-hover') &&
                !$('#pn-navigation-bar').hasClass('pn-navigation-menu-always'))
                calcBodyMarginTop = bodyMarginTopAlg2;

            //case-5-7
            if($('#pn-navigation-bar').hasClass('pn-no-sections') ||
                (!$('#pn-navigation-bar').hasClass('pn-no-sections') &&
                    $('#pn-navigation-bar').hasClass('pn-sections-marks-on-hover') &&
                    ($('#pn-navigation-bar').hasClass('pn-navigation-menu-on-hover') ||
                        $('#pn-navigation-bar').hasClass('pn-navigation-menu-disabled'))))
                calcBodyMarginTop = bodyMarginTopAlg3;
        }
    }


    function setBodyMarginTop()
    {
        if(!parseInt(pn_config.overlap_site_content))
        {
            if(!$('#pn-navigation-bar').hasClass('pn-hover'))
                $('body').css('margin-top', bodyMarginTop + 'px');
        }
        else
            $('body').css('margin-top', '');
    }

    function handleNavBarTouch(event)
    {
        var $this = $(this);
        $this.addClass('pn-hover');
        $('.pn-section-mark').removeClass('pn-hover');
        $('.pn-section-tooltip-wrapper').addClass('pn-hide');
        $('.pn-nav-switch').removeClass('pn-hover');
        if(event.type=='touchstart' && !$(event.target).hasClass('pn-sections-list-wrapper'))
            return false;
    }

    function handleDesktopHoverIn(event)
    {
        //windows phone will trigger hoverin, ignore it
        if(navigator.userAgent.match(/Windows Phone/i))
            return;

        var $this = $(this);
        $this.addClass('pn-hover');

        if($this.hasClass('pn-section-mark'))
            $this.find('.pn-section-tooltip-wrapper').removeClass('pn-hide');
    }

    function handleDesktopHoverOut(event)
    {
        //windows phone will trigger hoverout, ignore it
        if(navigator.userAgent.match(/Windows Phone/i))
            return;

        var $this = $(this);

        if(!($this.is('#pn-navigation-bar') && $('.pn-nav-switch.open').length))
            $this.removeClass('pn-hover');
    }

    function handleDocumentClickTouch(event)
    {
        var $target = $(event.target);
        if(event.type=='click' && !$target.closest('#pn-navigation-bar').length)
        {
            $('#pn-navigation-bar').removeClass('pn-hover')
            $('.pn-section-mark').removeClass('pn-hover');
            $('.pn-section-tooltip-wrapper').addClass('pn-hide');
            closeSectionsMenu();
        }

        if(event.type=='touchstart' && !$(event.target).hasClass('pn-sections-list-wrapper'))
        {
            $('#pn-navigation-bar').removeClass('pn-hover')
            $('.pn-section-mark').removeClass('pn-hover');
            $('.pn-section-tooltip-wrapper').addClass('pn-hide');
            closeSectionsMenu();
        }
    }

    function handlePaginationClickTouch(event)
    {
        var $this = $(this);
        if($this.hasClass('pn-inactive'))
            return false;
        var targetSection = $this.attr('data-section-class');
        var $targetSection = $('.' + targetSection);
        scrollToSection($targetSection.offset().top);

        $('#pn-navigation-bar').removeClass('pn-hover');
        $('.pn-nav-switch').removeClass('pn-hover');
        closeSectionsMenu();
        $this.parents('.pn-section-mark').removeClass('pn-hover');
        $this.parents('.pn-section-tooltip-wrapper').addClass('pn-hide');

        if(event.type=='touchstart')
            return false;
    }

    function handleNavigationWidgetClickTouch(event)
    {
        var $this = $(this);
        var $section = $('.' + $this.attr('data-section-class'));
        scrollToSection($section.offset().top);
        return false;
    }

    function handleNavSectionsClickTouch(event)
    {
        var $this = $(this);
        var $section = $('.' + $this.attr('data-section-class'));
        scrollToSection($section.offset().top);

        $('#pn-navigation-bar').removeClass('pn-hover');
        if(event.type=='touchstart')
        {
            $('.pn-section-mark').removeClass('pn-hover');
            $('.pn-section-tooltip-wrapper').addClass('pn-hide');
        }
        closeSectionsMenu();

        if(event.type=='touchstart')
            return false;
    }

    function handleNavSwitchClickTouch(event)
    {
        var $this = $(this);
        if($this.hasClass('inactive'))
            return;

        if(event.type=='touchstart')
        {
            $('.pn-section-mark').removeClass('pn-hover');
            $('.pn-section-tooltip-wrapper').addClass('pn-hide');
            $this.addClass('pn-hover');
        }

        if($this.hasClass('open'))
            closeSectionsMenu();
        else
            openSectionsMenu();

        if(event.type=='touchstart')
            return false;
    }

    function handleProgressBarClickTouch(event)
    {
        var $this = $(this);
        var $target = $(event.target);
        //don't react if user clicked in section tooltip
        if($target.closest('.pn-section-mark').length)
            return;

        if(event.type=='touchstart')
        {
            $('#pn-navigation-bar').addClass('pn-hover');
            $('.pn-section-mark').removeClass('pn-hover');
            $('.pn-section-tooltip-wrapper').addClass('pn-hide');
            $('.pn-nav-switch').removeClass('pn-hover');
        }

        $('.pn-nav-switch').removeClass('pn-hover');
        closeSectionsMenu();

        var positionX = (event.type=="touchstart" ? event.originalEvent.touches[0].pageX : event.clientX);

        var offset;
        if(pn_config.progress_bar_algorithm=='algorithm_1')
            offset = calcPosYAlg1(positionX);
        if(pn_config.progress_bar_algorithm=='algorithm_2')
            offset = calcPosYAlg2(positionX);

        $('html, body').animate({scrollTop: offset}, 400);

        if(event.type=='touchstart')
            return false;
    }

    function handleSectionMarkClickTouch(event)
    {
        var $this = $(this);
        var $target = $(event.target);
        //react only if the user clicked on marker, not the tooltip
        if(!$target.is($this))
            return;

        if(event.type=='touchstart')
        {
            $('#pn-navigation-bar').addClass('pn-hover');
            $('.pn-section-mark').removeClass('pn-hover');
            $('.pn-section-tooltip-wrapper').addClass('pn-hide');
            $('.pn-nav-switch').removeClass('pn-hover');
            $this.addClass('pn-hover');
            $this.find('.pn-section-tooltip-wrapper').removeClass('pn-hide');
        }

        $('.pn-nav-switch').removeClass('pn-hover');
        var $section = $('.' + $this.attr('data-section-class'));
        scrollToSection($section.offset().top);

        if(event.type=='touchstart')
            return false;
    }

    function handleScreenChange()
    {
        //Explanation-5
        calcProgress();
    }

    function scrollToSection(sectionOffsetTop)
    {
        $('html, body').animate({scrollTop: sectionOffsetTop-sectionOffsetTopWindow-offsetTop}, 400);
    }

    function closeSectionsMenu()
    {
        $('.pn-nav-switch').removeClass('open').addClass('inactive');
        $('.pn-sections-list-wrapper').slideUp({
            'duration'		: 300,
            'easing'		: 'easeInOutCubic',
            'complete'		: setSectionsMenuHeight,
        });
    }

    function openSectionsMenu()
    {
        var $this = $('.pn-nav-switch');
        $this.addClass('open inactive');
        $('.pn-sections-list-wrapper').css({
            'display': 'block',
            'height': '',
        });
        var windowOffsetBottom = window.innerHeight+$(window).scrollTop();
        var sectionsMenuHeightAuto = $('.pn-sections-list-wrapper').outerHeight();
        var sectionsMenuOffsetBottom = sectionsMenuHeightAuto+$('.pn-sections-list-wrapper').offset().top;
        var diff = windowOffsetBottom-sectionsMenuOffsetBottom-20;
        var sectionsMenuHeightNew = sectionsMenuHeightAuto+diff;
        $('.pn-sections-list-wrapper').css({
            'height': '0',
            'overflow-y': '',
            'overflow-x': '',
        });

        if(diff>0)
        {
            $('.pn-sections-list-wrapper').stop(false, true).animate({
                    height: sectionsMenuHeightAuto + 'px',
                },
                {
                    'duration'		: 300,
                    'easing'		: 'easeInOutCubic',
                    'complete'		: function() {
                        $this.removeClass('inactive');
                    },
                });
        }
        else
        {
            $('.pn-sections-list-wrapper').css({
                'overflow-y': 'scroll',
                'overflow-x': 'hidden',
            });
            $('.pn-sections-list-wrapper').stop(false, true).animate({
                    'height': sectionsMenuHeightNew + 'px',
                },
                {
                    'duration'		: 300,
                    'easing'		: 'easeInOutCubic',
                    'complete'		: function() {
                        $this.removeClass('inactive');
                    },
                });
        }
    }

    function setSectionsMenuHeight()
    {
        $('.pn-nav-switch').removeClass('inactive');

        if($('.pn-sections-list-wrapper').is(':visible'))
        {
            var windowOffsetBottom = window.innerHeight+$(window).scrollTop();
            var sectionsMenuHeightAuto;
            var temp = $('.pn-sections-list-wrapper').outerHeight();
            sectionsMenuHeightAuto = $('.pn-sections-list-wrapper').css('height', '').outerHeight();
            $('.pn-sections-list-wrapper').css('height', temp + 'px');
            var sectionsMenuOffsetBottom = sectionsMenuHeightAuto+$('.pn-sections-list-wrapper').offset().top;
            var diff = windowOffsetBottom-sectionsMenuOffsetBottom-20;
            var sectionsMenuHeightNew = sectionsMenuHeightAuto+diff;

            if(diff>0)
            {
                $('.pn-sections-list-wrapper').css({
                    'height': sectionsMenuHeightAuto + 'px',
                    'overflow-y': '',
                    'overflow-x': '',
                });
            }
            else if(diff<0 && (sectionsMenuHeightNew!=$('.pn-sections-list-wrapper').outerHeight()))
            {
                $('.pn-sections-list-wrapper').css({
                    'height': sectionsMenuHeightNew + 'px',
                    'overflow-y': 'scroll',
                    'overflow-x': 'hidden',
                });
            }
        }
        else
        {
            $('.pn-sections-list-wrapper').css({
                'height': '',
                'overflow-y': '',
                'overflow-x': '',
            });
        }
    }

//	function calcBodyMarginTop()
//	{
//		var value = 0;
//		if($('#pn-navigation-bar').length)
//		{
//			//case-1;case-4
//			if(!$('#pn-navigation-bar').hasClass('pn-no-sections') &&
//				$('#pn-navigation-bar').hasClass('pn-navigation-menu-always'))
//			{
//				console.log('case 1 or 4');
//				value = parseInt($('.pn-navigation-info').css('padding-top'))+
//					$('.pn-navigation-info .pn-section-current').height()+
//					$('.pn-navigation-info .pn-spacing').outerHeight();
//
//				if($('#pn-navigation-bar').hasClass('pn-sections-marks-on-hover'))
//					value += $('#pn-navigation-bar .pn-progress-bar-wrapper .pn-progress-bar').height()+
//						parseInt($('#pn-navigation-bar .pn-progress-bar-wrapper').css('padding-bottom'));
//				else
//					value += $('#pn-navigation-bar .pn-progress-bar-wrapper').outerHeight();
//			}
//
//			//case-2;case-3
//			if(!$('#pn-navigation-bar').hasClass('pn-no-sections') &&
//				!$('#pn-navigation-bar').hasClass('pn-sections-marks-on-hover') &&
//				!$('#pn-navigation-bar').hasClass('pn-navigation-menu-always'))
//			{
//				console.log('case 2 or 3');
//				value = $('#pn-navigation-bar .pn-progress-bar-wrapper').height()+
//					parseInt($('#pn-navigation-bar .pn-progress-bar-wrapper').css('padding-top'));
//			}
//
//			//case-5-7
//			if($('#pn-navigation-bar').hasClass('pn-no-sections') ||
//				(!$('#pn-navigation-bar').hasClass('pn-no-sections') &&
//				$('#pn-navigation-bar').hasClass('pn-sections-marks-on-hover') &&
//					($('#pn-navigation-bar').hasClass('pn-navigation-menu-on-hover') ||
//					$('#pn-navigation-bar').hasClass('pn-navigation-menu-on-disabled'))))
//			{
//				console.log('case 5, 6, ... 12');
//				value = $('#pn-navigation-bar .pn-progress-bar-wrapper').height();
//			}
//		}
//
//		return Math.round(value);
//	}

    function calcPosXAlg1($val)
    {
        return Math.round(windowWidth*$val/(postHeight-windowHeight));
    }

    function calcPosXAlg2($val)
    {
        return Math.round(windowWidth*$val/postHeight);
    }

    function calcPosYAlg1($val)
    {
        return Math.round(($val/windowWidth)*(postHeight-windowHeight));
    }

    function calcPosYAlg2($val)
    {
        return Math.round(($val/windowWidth)*postHeight);
    }

    //case-0
    function bodyMarginTopAlg0()
    {
        return 0;
    }

    //case-1;case-4
    function bodyMarginTopAlg1()
    {
        var value;
        value = parseInt($('.pn-navigation-info').css('padding-top'))+
            $('.pn-navigation-info .pn-section-current').height()+
            $('.pn-navigation-info .pn-spacing').outerHeight();

        if($('#pn-navigation-bar').hasClass('pn-sections-marks-on-hover'))
            value += $('#pn-navigation-bar .pn-progress-bar-wrapper .pn-progress-bar').height()+
                parseInt($('#pn-navigation-bar .pn-progress-bar-wrapper').css('padding-bottom'));
        else
            value += $('#pn-navigation-bar .pn-progress-bar-wrapper').outerHeight();
        return Math.round(value);
    }

    //case-2;case-3
    function bodyMarginTopAlg2()
    {
        var value;
        value = $('#pn-navigation-bar .pn-progress-bar-wrapper').height()+parseInt($('#pn-navigation-bar .pn-progress-bar-wrapper').css('padding-top'));
        return Math.round(value);
    }

    //case-5-7
    function bodyMarginTopAlg3()
    {
        var value;
        value = $('#pn-navigation-bar .pn-progress-bar-wrapper').height();
        return Math.round(value);
    }

});
app.bind('default parallax', function(context) {
    const $parallaxItems = $('[js-parallax]', context);
    $parallaxItems.each(function(index, element) {
        const wrapper = $(element).closest('[js-parallax-wrapper]').get(0);
        new Rellax(element, {
            speed: 10,
            center: false,
            container: wrapper,
            relativeToWrapper: true,
        });
    });
});

var countSlider = new rSlider({
    target: '#slider_count',
    values: [0, 25, 50, 75, 100],
    range: false,
    set: [5],
    tooltip: false
});
var ageSlider = new rSlider({
    target: '#slider_age',
    values: [0, 2, 5, 7, 10],
    range: false,
    set: [5],
    tooltip: false
});
!function() {
    const baronTemplate = `
        <div class="scroller__clipper">
            <div class="scroller__container">
                <div js-scroller-content class="scroller__content"></div>
            </div>
        </div>
        <div class="scroller__vertical">
            <div class="scroller__vertical-bar"></div>
        </div>
        <div class="scroller__horizontal">
            <div class="scroller__horizontal-bar"></div>
        </div>
    `;

    app.bind('default scrollbar', (context) => {
        const $scrollbars = $('[js-scrollbar]', context).add($(context).filter('[js-scrollbar]'));

        $scrollbars.each((scrollbarIndex, scrollbarParent) => {
            const $scrollbarParent = $scrollbars.eq(scrollbarIndex);
            let baronVApi = $scrollbarParent.data('baron-v-api');
            let baronHApi = $scrollbarParent.data('baron-h-api');
            if ( baronVApi || baronHApi ) {
                $scrollbarParent.trigger('update.scrollbar');
                return;
            }
            const $contentOrigin = $scrollbarParent.contents();
            const $newTemplate = $(baronTemplate.replace(/\n/g, ''));

            $scrollbarParent.addClass('scroller is-scroller-inited');
            $newTemplate.appendTo($scrollbarParent);
            $contentOrigin.appendTo($newTemplate.find('[js-scroller-content]'));
            baronVApi = baron({
                cssGuru: true,
                root: scrollbarParent,
                scroller: '.scroller__container',
                track: '.scroller__vertical',
                bar: '.scroller__vertical-bar',
                barOnCls: 'is-scrollbar-vertical',
                scrollingCls: 'is-scrollbar-scrolling',
                draggingCls: 'is-scrollbar-dragging',
            });
            baronHApi = baron({
                cssGuru: true,
                root: scrollbarParent,
                scroller: '.scroller__container',
                track: '.scroller__horizontal',
                bar: '.scroller__horizontal-bar',
                barOnCls: 'is-scrollbar-horizontal',
                scrollingCls: 'is-scrollbar-scrolling',
                draggingCls: 'is-scrollbar-dragging',
                direction: 'h',
            });
            $scrollbarParent.data({
                'baron-v-api': baronVApi,
                'baron-h-api': baronHApi,
            });

            $scrollbarParent.off('.scrollbar').on({
                'update.scrollbar': (e) => {
                    requestAnimationFrame(() => {
                        baronHApi.scroller.style.removeProperty('width');
                        baronHApi.scroller.style.removeProperty('min-width');
                        baronHApi.scroller.style.removeProperty('max-width');
                        baronHApi.update();

                        baronVApi.scroller.style.removeProperty('height');
                        baronVApi.scroller.style.removeProperty('min-height');
                        baronVApi.scroller.style.removeProperty('max-height');
                        baronVApi.update();
                    });
                },
                'destroy-scrollbar.scrollbar': (e) => {
                    baronVApi && baronVApi.dispose();
                    baronHApi && baronHApi.dispose();
                    $scrollbarParent.removeData('baron-v-api');
                    $scrollbarParent.removeData('baron-h-api');
                },
            });
        });
    });

    app.bind('scrollbar-destroy', (context) => {
        const $scrollbars = $('[js-scrollbar]', context).add($(context).filter('[js-scrollbar]'));

        $scrollbars.trigger('destroy-scrollbar.scrollbar');
    });
}();
$(function(){
    $(".scrollbar-top-container").scroll(function(){
        let currentTable = $(this).closest('.chart-block__main').find('.table-wrapper');
        currentTable.scrollLeft($(this).scrollLeft());
    });
    $(".table-wrapper").scroll(function(){
        let currentTopScrollbar = $(this).closest('.chart-block__main').find('.scrollbar-top-container');
        currentTopScrollbar.scrollLeft($(this).scrollLeft());
    });
    $(window).on('load resize', function(){
        $('.table-wrapper').each(function() {
            let currentTable = $(this).find('.chart-table');
            let scrollbarTop = currentTable.closest('.chart-block__main').find('.scrollbar-top');
            if(scrollbarTop.length > 0){
                let currentHeightTable = currentTable.width();
                scrollbarTop.width(currentHeightTable);
            }
        });
    }).trigger('resize');
});

// app.bind('default', function () {
//     const $sliderBlock = $('.special-slider'),
//           $slider = $('.special-slider__list', $sliderBlock);
//
//     $slider.owlCarousel({
//         loop:true,
//         nav:false,
//         dots:true,
//         items:1
//     });
// });
app.bind('default sticky', (context) => {
    const $window = $(window);
    const $stickyItems = $('[js-sticky]', context);

    $stickyItems.off('.sticky').each((stickyIndex, stickyElement) => {
        const $stickyElement = $stickyItems.eq(stickyIndex);
        const stickyApi = new hcSticky(stickyElement, $.extend(true, {
            stickyClass: 'is-sticky',
        }, $stickyElement.data('sticky-options') || {}));

        $stickyElement.on({
            'update.sticky': (e) => {
                stickyApi.refresh();
            },
            'destroy.sticky': (e) => {
                stickyApi.destroy();
            },
        });
    });

    $window.on({
        'windowResized': (e, payload = {}) => {
            if ( payload.isBodyResized ) {
                $stickyItems.trigger('update.sticky');
            }
        },
    });
});


app.bind('default sticky_figure', (context) => {
    const $window = $(window);
    const $stickyItems = $('[js-sticky-figure]', context);

    $stickyItems.off('.sticky').each((stickyIndex, stickyElement) => {
        const $stickyItem = $(stickyElement);
        let offset = $stickyItem.offset();

        function stickyOffset() {
            if($window.scrollTop() >= offset.top){
                $stickyItem.addClass('is-sticky');
            }
            else {
                $stickyItem.removeClass('is-sticky');
            }
        }
        stickyOffset();

        $window.on({
            'resize': () => {
                stickyOffset();
            },
            'scroll': () => {
                stickyOffset();
            },
        });
    });

});

app.bind('default stretchy', function(context) {
    Stretchy.selectors.filter = "[js-input-autosize]";
});

(function () {
    "use strict";
    if (typeof window !== "undefined" && window.addEventListener) {
        var cache = Object.create(null); // holds xhr objects to prevent multiple requests
        var checkUseElems;
        var tid; // timeout id
        var debouncedCheck = function () {
            clearTimeout(tid);
            tid = setTimeout(checkUseElems, 100);
        };
        var unobserveChanges = function () {
            return;
        };
        var observeChanges = function () {
            var observer;
            window.addEventListener("resize", debouncedCheck, false);
            window.addEventListener("orientationchange", debouncedCheck, false);
            if (window.MutationObserver) {
                observer = new MutationObserver(debouncedCheck);
                observer.observe(document.documentElement, {
                    childList: true,
                    subtree: true,
                    attributes: true
                });
                unobserveChanges = function () {
                    try {
                        observer.disconnect();
                        window.removeEventListener("resize", debouncedCheck, false);
                        window.removeEventListener("orientationchange", debouncedCheck, false);
                    } catch (ignore) {}
                };
            } else {
                document.documentElement.addEventListener("DOMSubtreeModified", debouncedCheck, false);
                unobserveChanges = function () {
                    document.documentElement.removeEventListener("DOMSubtreeModified", debouncedCheck, false);
                    window.removeEventListener("resize", debouncedCheck, false);
                    window.removeEventListener("orientationchange", debouncedCheck, false);
                };
            }
        };
        var createRequest = function (url) {
            // In IE 9, cross origin requests can only be sent using XDomainRequest.
            // XDomainRequest would fail if CORS headers are not set.
            // Therefore, XDomainRequest should only be used with cross origin requests.
            function getOrigin(loc) {
                var a;
                if (loc.protocol !== undefined) {
                    a = loc;
                } else {
                    a = document.createElement("a");
                    a.href = loc;
                }
                return a.protocol.replace(/:/g, "") + a.host;
            }
            var Request;
            var origin;
            var origin2;
            if (window.XMLHttpRequest) {
                Request = new XMLHttpRequest();
                origin = getOrigin(location);
                origin2 = getOrigin(url);
                if (Request.withCredentials === undefined && origin2 !== "" && origin2 !== origin) {
                    Request = XDomainRequest || undefined;
                } else {
                    Request = XMLHttpRequest;
                }
            }
            return Request;
        };
        var xlinkNS = "http://www.w3.org/1999/xlink";
        checkUseElems = function () {
            var base;
            var bcr;
            var fallback = ""; // optional fallback URL in case no base path to SVG file was given and no symbol definition was found.
            var hash;
            var href;
            var i;
            var inProgressCount = 0;
            var isHidden;
            var Request;
            var url;
            var uses;
            var xhr;
            function observeIfDone() {
                // If done with making changes, start watching for chagnes in DOM again
                inProgressCount -= 1;
                if (inProgressCount === 0) { // if all xhrs were resolved
                    unobserveChanges(); // make sure to remove old handlers
                    observeChanges(); // watch for changes to DOM
                }
            }
            function attrUpdateFunc(spec) {
                return function () {
                    if (cache[spec.base] !== true) {
                        spec.useEl.setAttributeNS(xlinkNS, "xlink:href", "#" + spec.hash);
                        if (spec.useEl.hasAttribute("href")) {
                            spec.useEl.setAttribute("href", "#" + spec.hash);
                        }
                    }
                };
            }
            function onloadFunc(xhr) {
                return function () {
                    var body = document.body;
                    var x = document.createElement("x");
                    var svg;
                    xhr.onload = null;
                    x.innerHTML = xhr.responseText;
                    svg = x.getElementsByTagName("svg")[0];
                    if (svg) {
                        svg.setAttribute("aria-hidden", "true");
                        svg.style.position = "absolute";
                        svg.style.width = 0;
                        svg.style.height = 0;
                        svg.style.overflow = "hidden";
                        body.insertBefore(svg, body.firstChild);
                    }
                    observeIfDone();
                };
            }
            function onErrorTimeout(xhr) {
                return function () {
                    xhr.onerror = null;
                    xhr.ontimeout = null;
                    observeIfDone();
                };
            }
            unobserveChanges(); // stop watching for changes to DOM
            // find all use elements
            uses = document.getElementsByTagName("use");
            for (i = 0; i < uses.length; i += 1) {
                try {
                    bcr = uses[i].getBoundingClientRect();
                } catch (ignore) {
                    // failed to get bounding rectangle of the use element
                    bcr = false;
                }
                href = uses[i].getAttribute("href")
                    || uses[i].getAttributeNS(xlinkNS, "href")
                    || uses[i].getAttribute("xlink:href");
                if (href && href.split) {
                    url = href.split("#");
                } else {
                    url = ["", ""];
                }
                base = url[0];
                hash = url[1];
                isHidden = bcr && bcr.left === 0 && bcr.right === 0 && bcr.top === 0 && bcr.bottom === 0;
                if (bcr && bcr.width === 0 && bcr.height === 0 && !isHidden) {
                    // the use element is empty
                    // if there is a reference to an external SVG, try to fetch it
                    // use the optional fallback URL if there is no reference to an external SVG
                    if (fallback && !base.length && hash && !document.getElementById(hash)) {
                        base = fallback;
                    }
                    if (uses[i].hasAttribute("href")) {
                        uses[i].setAttributeNS(xlinkNS, "xlink:href", href);
                    }
                    if (base.length) {
                        // schedule updating xlink:href
                        xhr = cache[base];
                        if (xhr !== true) {
                            // true signifies that prepending the SVG was not required
                            setTimeout(attrUpdateFunc({
                                useEl: uses[i],
                                base: base,
                                hash: hash
                            }), 0);
                        }
                        if (xhr === undefined) {
                            Request = createRequest(base);
                            if (Request !== undefined) {
                                xhr = new Request();
                                cache[base] = xhr;
                                xhr.onload = onloadFunc(xhr);
                                xhr.onerror = onErrorTimeout(xhr);
                                xhr.ontimeout = onErrorTimeout(xhr);
                                xhr.open("GET", base);
                                xhr.send();
                                inProgressCount += 1;
                            }
                        }
                    }
                } else {
                    if (!isHidden) {
                        if (cache[base] === undefined) {
                            // remember this URL if the use element was not empty and no request was sent
                            cache[base] = true;
                        } else if (cache[base].onload) {
                            // if it turns out that prepending the SVG is not necessary,
                            // abort the in-progress xhr.
                            cache[base].abort();
                            delete cache[base].onload;
                            cache[base] = true;
                        }
                    } else if (base.length && cache[base]) {
                        setTimeout(attrUpdateFunc({
                            useEl: uses[i],
                            base: base,
                            hash: hash
                        }), 0);
                    }
                }
            }
            uses = "";
            inProgressCount += 1;
            observeIfDone();
        };
        var winLoad;
        winLoad = function () {
            window.removeEventListener("load", winLoad, false); // to prevent memory leaks
            tid = setTimeout(checkUseElems, 0);
        };
        if (document.readyState !== "complete") {
            // The load event fires when all resources have finished loading, which allows detecting whether SVG use elements are empty.
            window.addEventListener("load", winLoad, false);
        } else {
            // No need to add a listener if the document is already loaded, initialize immediately.
            winLoad();
        }
    }
}());
app.bind('default tableScrollable', function(context){
    const $tables = $('table', context).not('[data-scroll="false"]');

    $tables.each((i, item) => {
        const $table = $(item);
        let $tableWrapper = $('<div class="table-wrapper  -scrollbar" />');

        $table.wrap($tableWrapper);
        $tableWrapper = $table.parent();

        if ($table.width() > $tableWrapper.width()) {
            $tableWrapper.addClass('-arrow-hint');
        }
    });
});

app.bind('default basic tabby', function(context){
    $('[js-tabby-tab]', context).tabby();
});

app.bind('default tag-list', function (context) {
  let $agListToggle = $('[js-tag-list-toggle]', context);

  $agListToggle.off('.tagListToggle').on({
    'click.tagListToggle': (event) => {
      event.preventDefault();
      $(event.currentTarget).closest('[js-tag-list-target]')
        .toggleClass('tag-list_collapse');
    }
  })
});

app.bind('default basic tips', function(context) {
    const $window = $(window);
    const $simples = $('[js-tooltip]', context);
    const $dropdowns = $('[js-dropdown-tip]', context);

    const defaultOptions = {
        position: {
            viewport: $window,
            effect: false,
            my: 'top center',
            at: 'bottom center',
            adjust: {
                scroll: false,
                method: 'shift flipinvert',
                x: 0,
                y: 13
            },
        },
        content: {
            button: false,
        },
        show: {
            solo: true,
            event: deviceType.mobile ? 'click' : 'mouseenter'
        },
        hide: {
            delay: 150,
            fixed: true,
            event: deviceType.mobile ? 'unfocus' : 'mouseleave unfocus'
        },
        style: {
            classes: '',
            tip: {
                mimic: 'center',
                width: 8,
                height: 3,
            }
        },
        events: {
            show(e, api) {
                $window.trigger('tips.open');
                $(api.target).addClass('is-open');
            },
            hide(e, api) {
                $(api.target).removeClass('is-open');
            }
        }
    };

    const simpleOptions = {
        content: {
            button: false,
        },
        show: {
            solo: true,
            event: deviceType.mobile ? 'click' : 'mouseenter'
        },
        hide: {
            event: deviceType.mobile ? 'unfocus' : 'mouseleave unfocus'
        },
        style: {
            classes: 'qtip-simple',
        },
    };

    $simples.off('.tip').each(tipIndex => {
        const $tip = $simples.eq(tipIndex);
        let options = defaultOptions;

        if ($tip.data('qtip-options')) {
            options = $.extend(true, {}, options, $tip.data('qtip-options'));
        }

        if ($tip.data('type') && $tip.data('type') === 'simple') {
            options = $.extend(true, {}, options, simpleOptions);
        }

        $tip.qtip(options);
    }).on({
        'destroy.tip': (e) => {
            $(e.currentTarget).qtip('destroy', true);
        },
    });


    $dropdowns.off('.tip').each((tipIndex, tip) => {
        const $tip = $dropdowns.eq(tipIndex);
        const $tipClose = $tip.find('[js-tip-close]');


        ($tip.find('[js-dropdown-target]').length ? $tip.find('[js-dropdown-target]') : $tip).qtip($.extend(true, {}, defaultOptions, {
            style: {
                classes: 'qtip-dropdown',
            },
            content: {
                text: $tip.find('[js-dropdown-content]') || false,
            },
            events: {
                show(e, api) {
                    $tip.addClass('is-active');
                },
                hide(e, api) {
                    $tip.removeClass('is-active');
                }
            },
        }, $tip.data('qtip-options') || {}));
    });
});

app.bind('default toggler', function (context) {
    $('[js-toggler]', context).toggler();
});
